import { r as registerInstance, h as h$1, e as Host, g as getElement } from './index-6c727dca.js';
import './component-errors-b6f1109b.js';
import { k as klassList } from './utils-c16d9285.js';

const v = "5.6.6";
const fr = 30;
const ip = 0;
const op = 105;
const w = 575;
const h = 400;
const nm = "Embrace_LoadingAnimation_Long";
const ddd = 0;
const assets = [
];
const layers = [
	{
		ddd: 0,
		ind: 1,
		ty: 3,
		nm: "master control",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 0,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					263.5,
					225.5,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "front r leg",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					232,
					167.572,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					279.173,
					95.811,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.533,
								0.533,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.622,
								0.622,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 0,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.376,
								0.376,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 15,
						s: [
							93,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.559,
								0.528,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 34,
						s: [
							103,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 44,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.408,
								0.408,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 65,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 72,
						s: [
							103.5,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 80,
						s: [
							103.5,
							100,
							100
						]
					},
					{
						t: 95,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										11.392,
										3.027
									],
									[
										1.289,
										-8.237
									]
								],
								o: [
									[
										6.019,
										3.614
									],
									[
										4.159,
										-6.48
									]
								],
								v: [
									[
										-22.156,
										-9.737
									],
									[
										-13.003,
										9.677
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.579999976065,
								0.211999990426,
								0.556999954523,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								286.026,
								86.329
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										8.357,
										1.61
									],
									[
										0.086,
										-4.643
									]
								],
								o: [
									[
										5.852,
										3.552
									],
									[
										2.868,
										-4.333
									]
								],
								v: [
									[
										-20.322,
										-6.489
									],
									[
										-13.546,
										6.43
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.579999976065,
								0.211999990426,
								0.556999954523,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								280.112,
								89.555
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.692,
										y: 1
									},
									o: {
										x: 0.324,
										y: 0
									},
									t: 12,
									s: [
										{
											i: [
												[
													-35.343,
													-16.196
												],
												[
													-8.761,
													1.523
												],
												[
													41.9,
													3.482
												],
												[
													11.306,
													7.995
												]
											],
											o: [
												[
													11.888,
													1.213
												],
												[
													-28.852,
													-1.663
												],
												[
													-29.67,
													-12.391
												],
												[
													2.096,
													4.428
												]
											],
											v: [
												[
													-28.985,
													25.669
												],
												[
													95.047,
													27.968
												],
												[
													-27.987,
													22.749
												],
												[
													-110.876,
													-26.57
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.54,
										y: 0
									},
									t: 26,
									s: [
										{
											i: [
												[
													-32.434,
													-21.435
												],
												[
													-8.761,
													1.523
												],
												[
													44.189,
													9.889
												],
												[
													9.271,
													10.285
												]
											],
											o: [
												[
													11.56,
													3.025
												],
												[
													-27.05,
													-4.708
												],
												[
													-27.413,
													-16.803
												],
												[
													1.071,
													4.781
												]
											],
											v: [
												[
													-20.458,
													7.038
												],
												[
													96.626,
													27.093
												],
												[
													-19.023,
													4.306
												],
												[
													-90.133,
													-57.105
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.561,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 35,
									s: [
										{
											i: [
												[
													-34.244,
													-18.176
												],
												[
													-8.761,
													1.523
												],
												[
													42.765,
													5.903
												],
												[
													11.258,
													7.924
												]
											],
											o: [
												[
													11.764,
													1.898
												],
												[
													-28.171,
													-2.814
												],
												[
													-28.817,
													-14.059
												],
												[
													2.094,
													4.398
												]
											],
											v: [
												[
													-19.149,
													20.039
												],
												[
													95.703,
													27.816
												],
												[
													-17.985,
													17.19
												],
												[
													-108.897,
													-31.538
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 42,
									s: [
										{
											i: [
												[
													-35.343,
													-16.196
												],
												[
													-8.761,
													1.523
												],
												[
													41.9,
													3.482
												],
												[
													11.306,
													7.995
												]
											],
											o: [
												[
													11.888,
													1.213
												],
												[
													-28.852,
													-1.663
												],
												[
													-29.67,
													-12.391
												],
												[
													2.096,
													4.428
												]
											],
											v: [
												[
													-28.985,
													25.669
												],
												[
													95.047,
													27.968
												],
												[
													-27.987,
													22.749
												],
												[
													-110.876,
													-26.57
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.408,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 65,
									s: [
										{
											i: [
												[
													-35.343,
													-16.196
												],
												[
													-8.761,
													1.523
												],
												[
													41.9,
													3.482
												],
												[
													11.306,
													7.995
												]
											],
											o: [
												[
													11.888,
													1.213
												],
												[
													-28.852,
													-1.663
												],
												[
													-29.67,
													-12.391
												],
												[
													2.096,
													4.428
												]
											],
											v: [
												[
													-28.985,
													25.669
												],
												[
													95.047,
													27.968
												],
												[
													-27.987,
													22.749
												],
												[
													-110.876,
													-26.57
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 72,
									s: [
										{
											i: [
												[
													-35.343,
													-16.196
												],
												[
													-8.761,
													1.523
												],
												[
													41.9,
													3.482
												],
												[
													11.757,
													7.315
												]
											],
											o: [
												[
													11.888,
													1.213
												],
												[
													-28.852,
													-1.663
												],
												[
													-29.67,
													-12.391
												],
												[
													2.353,
													4.297
												]
											],
											v: [
												[
													-28.985,
													25.669
												],
												[
													95.705,
													28.036
												],
												[
													-27.987,
													22.749
												],
												[
													-114.981,
													-21.721
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 85,
									s: [
										{
											i: [
												[
													-35.343,
													-16.196
												],
												[
													-8.761,
													1.523
												],
												[
													41.9,
													3.482
												],
												[
													11.757,
													7.315
												]
											],
											o: [
												[
													11.888,
													1.213
												],
												[
													-28.852,
													-1.663
												],
												[
													-29.67,
													-12.391
												],
												[
													2.353,
													4.297
												]
											],
											v: [
												[
													-28.985,
													25.669
												],
												[
													95.705,
													28.027
												],
												[
													-27.987,
													22.749
												],
												[
													-114.981,
													-21.721
												]
											],
											c: true
										}
									]
								},
								{
									t: 102,
									s: [
										{
											i: [
												[
													-35.343,
													-16.196
												],
												[
													-8.761,
													1.523
												],
												[
													41.9,
													3.482
												],
												[
													11.306,
													7.995
												]
											],
											o: [
												[
													11.888,
													1.213
												],
												[
													-28.852,
													-1.663
												],
												[
													-29.67,
													-12.391
												],
												[
													2.096,
													4.428
												]
											],
											v: [
												[
													-28.985,
													25.669
												],
												[
													94.922,
													28.027
												],
												[
													-27.987,
													22.749
												],
												[
													-110.876,
													-26.57
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.579999976065,
								0.211999990426,
								0.556999954523,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								134.729,
								39.979
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 3",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.692,
										y: 1
									},
									o: {
										x: 0.324,
										y: 0
									},
									t: 12,
									s: [
										{
											i: [
												[
													7.865,
													8.72
												],
												[
													-21.658,
													-6.791
												]
											],
											o: [
												[
													0,
													0
												],
												[
													-13.865,
													-1.221
												]
											],
											v: [
												[
													-20.653,
													-7.67
												],
												[
													20.653,
													7.67
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.54,
										y: 0
									},
									t: 26,
									s: [
										{
											i: [
												[
													9.1,
													9.025
												],
												[
													-20.357,
													-10.039
												]
											],
											o: [
												[
													0,
													0
												],
												[
													-13.513,
													-3.337
												]
											],
											v: [
												[
													-13.564,
													-33.619
												],
												[
													25.216,
													-14.878
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.561,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 35,
									s: [
										{
											i: [
												[
													8.926,
													7.829
												],
												[
													-21.166,
													-8.018
												]
											],
											o: [
												[
													0,
													0
												],
												[
													-13.732,
													-2.021
												]
											],
											v: [
												[
													-11.598,
													-14.084
												],
												[
													28.991,
													0.56
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 42,
									s: [
										{
											i: [
												[
													7.865,
													8.72
												],
												[
													-21.658,
													-6.791
												]
											],
											o: [
												[
													0,
													0
												],
												[
													-13.865,
													-1.221
												]
											],
											v: [
												[
													-20.653,
													-7.67
												],
												[
													20.653,
													7.67
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.408,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 65,
									s: [
										{
											i: [
												[
													7.865,
													8.72
												],
												[
													-21.658,
													-6.791
												]
											],
											o: [
												[
													0,
													0
												],
												[
													-13.865,
													-1.221
												]
											],
											v: [
												[
													-20.653,
													-7.67
												],
												[
													20.653,
													7.67
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 72,
									s: [
										{
											i: [
												[
													8.365,
													8.242
												],
												[
													-21.658,
													-6.791
												]
											],
											o: [
												[
													0,
													0
												],
												[
													-13.865,
													-1.221
												]
											],
											v: [
												[
													-21.594,
													-4.947
												],
												[
													20.653,
													7.67
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 85,
									s: [
										{
											i: [
												[
													8.365,
													8.242
												],
												[
													-21.658,
													-6.791
												]
											],
											o: [
												[
													0,
													0
												],
												[
													-13.865,
													-1.221
												]
											],
											v: [
												[
													-21.594,
													-4.947
												],
												[
													20.653,
													7.67
												]
											],
											c: true
										}
									]
								},
								{
									t: 102,
									s: [
										{
											i: [
												[
													7.865,
													8.72
												],
												[
													-21.658,
													-6.791
												]
											],
											o: [
												[
													0,
													0
												],
												[
													-13.865,
													-1.221
												]
											],
											v: [
												[
													-20.653,
													-7.67
												],
												[
													20.653,
													7.67
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.579999976065,
								0.211999990426,
								0.556999954523,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								61.739,
								85.583
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 4",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 4,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.692,
										y: 1
									},
									o: {
										x: 0.324,
										y: 0
									},
									t: 12,
									s: [
										{
											i: [
												[
													-14.44,
													-11.046
												],
												[
													0,
													0
												],
												[
													-11.032,
													-0.88
												],
												[
													3.557,
													-12.125
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													7.231,
													1.672
												],
												[
													0,
													0
												]
											],
											o: [
												[
													47.891,
													36.635
												],
												[
													0,
													0
												],
												[
													23.685,
													1.889
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-29.548,
													0.297
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-123.094,
													-33.787
												],
												[
													-42.541,
													16.14
												],
												[
													105.533,
													21.148
												],
												[
													129.115,
													47.639
												],
												[
													103.348,
													47.652
												],
												[
													80.602,
													47.664
												],
												[
													-29.1,
													47.719
												],
												[
													-75.904,
													42.737
												],
												[
													-148.547,
													12.344
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.54,
										y: 0
									},
									t: 26,
									s: [
										{
											i: [
												[
													-11.658,
													-13.951
												],
												[
													0,
													0
												],
												[
													-72.788,
													-6.175
												],
												[
													3.557,
													-12.125
												],
												[
													6.493,
													0.178
												],
												[
													11.357,
													0.686
												],
												[
													0,
													0
												],
												[
													6.888,
													2.763
												],
												[
													0,
													0
												]
											],
											o: [
												[
													38.664,
													46.269
												],
												[
													0,
													0
												],
												[
													23.675,
													2.008
												],
												[
													0,
													0
												],
												[
													-6.493,
													-0.178
												],
												[
													-11.005,
													-0.665
												],
												[
													-29.243,
													-4.247
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-102.632,
													-63.941
												],
												[
													-33.829,
													-2.398
												],
												[
													105.533,
													21.148
												],
												[
													129.115,
													47.639
												],
												[
													104.633,
													47.652
												],
												[
													78.098,
													46.037
												],
												[
													-25.4,
													30.871
												],
												[
													-70.883,
													18.756
												],
												[
													-138.363,
													-15.535
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.561,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 35,
									s: [
										{
											i: [
												[
													-15.451,
													-9.38
												],
												[
													0,
													0
												],
												[
													-34.372,
													-2.881
												],
												[
													3.557,
													-12.125
												],
												[
													2.454,
													0.067
												],
												[
													4.292,
													0.259
												],
												[
													0,
													0
												],
												[
													7.101,
													2.084
												],
												[
													0,
													0
												]
											],
											o: [
												[
													50.632,
													30.738
												],
												[
													0,
													0
												],
												[
													23.681,
													1.934
												],
												[
													0,
													0
												],
												[
													-2.454,
													-0.067
												],
												[
													-4.159,
													-0.251
												],
												[
													-29.433,
													-1.42
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-121.123,
													-38.765
												],
												[
													-32.635,
													10.545
												],
												[
													105.592,
													21.327
												],
												[
													129.174,
													47.818
												],
												[
													103.893,
													47.831
												],
												[
													79.715,
													47.228
												],
												[
													-21.088,
													42.763
												],
												[
													-67.393,
													35.085
												],
												[
													-146.329,
													7.155
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 42,
									s: [
										{
											i: [
												[
													-14.44,
													-11.046
												],
												[
													0,
													0
												],
												[
													-11.032,
													-0.88
												],
												[
													3.557,
													-12.125
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													7.231,
													1.672
												],
												[
													0,
													0
												]
											],
											o: [
												[
													47.891,
													36.635
												],
												[
													0,
													0
												],
												[
													23.685,
													1.889
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-29.548,
													0.297
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-123.094,
													-33.787
												],
												[
													-42.541,
													16.14
												],
												[
													105.533,
													21.148
												],
												[
													129.115,
													47.639
												],
												[
													103.348,
													47.652
												],
												[
													80.602,
													47.664
												],
												[
													-29.1,
													47.719
												],
												[
													-75.904,
													42.737
												],
												[
													-148.547,
													12.344
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.408,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 65,
									s: [
										{
											i: [
												[
													-14.44,
													-11.046
												],
												[
													0,
													0
												],
												[
													-11.032,
													-0.88
												],
												[
													3.557,
													-12.125
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													7.231,
													1.672
												],
												[
													0,
													0
												]
											],
											o: [
												[
													47.891,
													36.635
												],
												[
													0,
													0
												],
												[
													23.685,
													1.889
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-29.548,
													0.297
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-123.094,
													-33.787
												],
												[
													-42.541,
													16.14
												],
												[
													105.533,
													21.148
												],
												[
													129.115,
													47.639
												],
												[
													109.708,
													47.649
												],
												[
													93.611,
													47.657
												],
												[
													-29.1,
													47.719
												],
												[
													-75.904,
													42.737
												],
												[
													-148.547,
													12.344
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 72,
									s: [
										{
											i: [
												[
													-15.065,
													-10.177
												],
												[
													0,
													0
												],
												[
													-11.032,
													-0.88
												],
												[
													3.557,
													-12.125
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													7.231,
													1.672
												],
												[
													0,
													0
												]
											],
											o: [
												[
													49.965,
													33.752
												],
												[
													0,
													0
												],
												[
													23.685,
													1.889
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-29.548,
													0.297
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-127.139,
													-29.048
												],
												[
													-42.541,
													16.14
												],
												[
													106.191,
													21.217
												],
												[
													129.773,
													47.708
												],
												[
													110.285,
													47.709
												],
												[
													94.121,
													47.71
												],
												[
													-29.1,
													47.719
												],
												[
													-75.904,
													42.737
												],
												[
													-149.832,
													18.501
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 85,
									s: [
										{
											i: [
												[
													-15.065,
													-10.177
												],
												[
													0,
													0
												],
												[
													-11.032,
													-0.88
												],
												[
													3.557,
													-12.125
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													7.231,
													1.672
												],
												[
													0,
													0
												]
											],
											o: [
												[
													49.965,
													33.752
												],
												[
													0,
													0
												],
												[
													23.685,
													1.889
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-29.548,
													0.297
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-127.139,
													-29.048
												],
												[
													-42.541,
													16.14
												],
												[
													106.191,
													21.208
												],
												[
													129.773,
													47.699
												],
												[
													110.284,
													47.701
												],
												[
													94.121,
													47.703
												],
												[
													-29.1,
													47.719
												],
												[
													-75.904,
													42.737
												],
												[
													-149.832,
													18.501
												]
											],
											c: true
										}
									]
								},
								{
									t: 102,
									s: [
										{
											i: [
												[
													-14.44,
													-11.046
												],
												[
													0,
													0
												],
												[
													-11.032,
													-0.88
												],
												[
													3.557,
													-12.125
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													7.231,
													1.672
												],
												[
													0,
													0
												]
											],
											o: [
												[
													47.891,
													36.635
												],
												[
													0,
													0
												],
												[
													23.685,
													1.889
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-29.548,
													0.297
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-123.094,
													-33.787
												],
												[
													-42.541,
													16.14
												],
												[
													105.408,
													21.208
												],
												[
													128.99,
													47.699
												],
												[
													109.598,
													47.701
												],
												[
													93.514,
													47.703
												],
												[
													-29.1,
													47.719
												],
												[
													-75.904,
													42.737
												],
												[
													-148.547,
													12.344
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								0.808000033509,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								148.797,
								48.266
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 5",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 5,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "ball",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.34
							],
							y: [
								0.626
							]
						},
						o: {
							x: [
								0.534
							],
							y: [
								0
							]
						},
						t: 9,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.576
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.257
							],
							y: [
								0.604
							]
						},
						t: 29.75,
						s: [
							353
						]
					},
					{
						i: {
							x: [
								0.716
							],
							y: [
								0.67
							]
						},
						o: {
							x: [
								0.472
							],
							y: [
								0
							]
						},
						t: 46,
						s: [
							420
						]
					},
					{
						i: {
							x: [
								0.529
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.089
							],
							y: [
								0.094
							]
						},
						t: 69,
						s: [
							340
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 84,
						s: [
							362
						]
					},
					{
						i: {
							x: [
								0.833
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 93.078,
						s: [
							359
						]
					},
					{
						t: 96.96875,
						s: [
							360
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.562,
							y: 0.945
						},
						o: {
							x: 0.398,
							y: 0
						},
						t: 9,
						s: [
							200.375,
							124.563,
							0
						],
						to: [
							19.777,
							-16.331,
							0
						],
						ti: [
							-14.16,
							-0.322,
							0
						]
					},
					{
						i: {
							x: 0.852,
							y: 1
						},
						o: {
							x: 0.957,
							y: 0.122
						},
						t: 21,
						s: [
							243.257,
							10.188,
							0
						],
						to: [
							4,
							0.563,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.564,
							y: 0.797
						},
						o: {
							x: 0.341,
							y: 0
						},
						t: 30,
						s: [
							252.25,
							108.438,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.412,
							y: 0.904
						},
						o: {
							x: 0.154,
							y: 0.175
						},
						t: 31,
						s: [
							253.371,
							119.566,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-2.169,
							-0.037,
							0
						]
					},
					{
						i: {
							x: 0.87,
							y: 1
						},
						o: {
							x: 0.684,
							y: 0.119
						},
						t: 34.938,
						s: [
							258.375,
							102.563,
							0
						],
						to: [
							3.625,
							0.063,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.157,
							y: 0.793
						},
						o: {
							x: 0.116,
							y: 0
						},
						t: 40.125,
						s: [
							264.625,
							124.438,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.935,
							y: 1
						},
						o: {
							x: 0.7,
							y: 0.2
						},
						t: 42.719,
						s: [
							264.375,
							119.688,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.642,
							y: 0.149
						},
						o: {
							x: 0.529,
							y: 0
						},
						t: 45.313,
						s: [
							264.063,
							124.313,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.415,
							y: 1
						},
						o: {
							x: 0.159,
							y: 0.315
						},
						t: 46.609,
						s: [
							263.587,
							123.381,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.94,
							y: 0.98
						},
						o: {
							x: 0.609,
							y: 0.087
						},
						t: 48,
						s: [
							262.75,
							124.438,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.48,
							y: 1
						},
						o: {
							x: 0.093,
							y: 0.103
						},
						t: 69,
						s: [
							181.875,
							124.438,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.343,
							y: 0
						},
						t: 84,
						s: [
							202.875,
							124.563,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 93.078,
						s: [
							199.875,
							124.563,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 96.96875,
						s: [
							200.375,
							124.563,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					67.101,
					43.076,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								1,
								0.833,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 25,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0.167,
								0
							]
						},
						t: 30,
						s: [
							100,
							130,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 32,
						s: [
							100,
							95,
							100
						]
					},
					{
						t: 34,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										-2.358,
										1.377
									],
									[
										0,
										0
									]
								],
								v: [
									[
										2.359,
										-0.365
									],
									[
										-2.359,
										-1.013
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.804000016755,
								0.866999966491,
								0.2,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3.258,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								28.121,
								30.552
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										-0.496,
										1.551
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-0.139,
										-2.107
									],
									[
										0.635,
										2.107
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.804000016755,
								0.866999966491,
								0.2,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3.258,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								75.694,
								83.529
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										2.04,
										-0.325
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-2.473,
										-0.479
									],
									[
										2.473,
										0.804
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.804000016755,
								0.866999966491,
								0.2,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3.258,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								109.661,
								38.875
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 3",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										-2.095,
										-1.429
									],
									[
										0,
										0
									]
								],
								v: [
									[
										1.521,
										1.133
									],
									[
										-1.521,
										-1.133
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.804000016755,
								0.866999966491,
								0.2,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3.258,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								103.454,
								61.623
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 4",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 4,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										-3.153,
										3.525
									],
									[
										0,
										0
									]
								],
								v: [
									[
										1.677,
										-1.763
									],
									[
										-1.677,
										1.512
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.804000016755,
								0.866999966491,
								0.2,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3.258,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								100.206,
								18.934
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 5",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 5,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										-0.192,
										-1.193
									]
								],
								o: [
									[
										0.058,
										1.638
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-0.218,
										-2.13
									],
									[
										0.218,
										2.13
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.804000016755,
								0.866999966491,
								0.2,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3.258,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								42.647,
								10.274
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 6",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 6,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-0.842,
										0.836
									],
									[
										-0.787,
										0.883
									],
									[
										-0.732,
										0.924
									],
									[
										-0.673,
										0.967
									],
									[
										-0.613,
										1.005
									],
									[
										-0.555,
										1.04
									],
									[
										-0.493,
										1.067
									],
									[
										-0.435,
										1.094
									],
									[
										-0.375,
										1.115
									],
									[
										-0.318,
										1.133
									],
									[
										-0.263,
										1.146
									],
									[
										-0.374,
										1.072
									],
									[
										-0.509,
										1.015
									],
									[
										-0.662,
										0.926
									],
									[
										-0.816,
										0.804
									],
									[
										-0.962,
										0.641
									],
									[
										-1.075,
										0.45
									],
									[
										-1.149,
										0.242
									],
									[
										-1.178,
										0.032
									],
									[
										-1.167,
										-0.17
									],
									[
										-1.121,
										-0.362
									],
									[
										-1.038,
										-0.549
									],
									[
										-0.919,
										-0.73
									],
									[
										-0.751,
										-0.903
									],
									[
										-0.528,
										-1.06
									],
									[
										-0.254,
										-1.176
									],
									[
										0.042,
										-1.225
									],
									[
										0.313,
										-1.205
									],
									[
										0.53,
										-1.135
									],
									[
										0.687,
										-1.049
									],
									[
										0.798,
										-0.96
									],
									[
										0.877,
										-0.88
									],
									[
										0.939,
										-0.809
									],
									[
										0.983,
										-0.749
									],
									[
										0.874,
										-0.749
									],
									[
										0.823,
										-0.806
									],
									[
										0.758,
										-0.864
									],
									[
										0.685,
										-0.927
									],
									[
										0.597,
										-0.99
									],
									[
										0.492,
										-1.049
									],
									[
										0.379,
										-1.101
									],
									[
										0.256,
										-1.142
									],
									[
										0.132,
										-1.17
									],
									[
										0.011,
										-1.181
									]
								],
								o: [
									[
										0.796,
										-0.792
									],
									[
										0.749,
										-0.84
									],
									[
										0.697,
										-0.886
									],
									[
										0.643,
										-0.926
									],
									[
										0.59,
										-0.963
									],
									[
										0.531,
										-0.995
									],
									[
										0.474,
										-1.026
									],
									[
										0.418,
										-1.05
									],
									[
										0.362,
										-1.071
									],
									[
										0.307,
										-1.089
									],
									[
										0.277,
										-1.206
									],
									[
										0.407,
										-1.169
									],
									[
										0.555,
										-1.104
									],
									[
										0.713,
										-1.002
									],
									[
										0.869,
										-0.856
									],
									[
										1.003,
										-0.672
									],
									[
										1.104,
										-0.463
									],
									[
										1.166,
										-0.247
									],
									[
										1.189,
										-0.033
									],
									[
										1.179,
										0.171
									],
									[
										1.136,
										0.368
									],
									[
										1.057,
										0.557
									],
									[
										0.938,
										0.744
									],
									[
										0.76,
										0.915
									],
									[
										0.525,
										1.052
									],
									[
										0.242,
										1.126
									],
									[
										-0.04,
										1.132
									],
									[
										-0.282,
										1.086
									],
									[
										-0.472,
										1.017
									],
									[
										-0.614,
										0.938
									],
									[
										-0.721,
										0.867
									],
									[
										-0.801,
										0.802
									],
									[
										-0.86,
										0.744
									],
									[
										-0.969,
										0.739
									],
									[
										-0.927,
										0.794
									],
									[
										-0.871,
										0.853
									],
									[
										-0.805,
										0.916
									],
									[
										-0.723,
										0.978
									],
									[
										-0.625,
										1.038
									],
									[
										-0.516,
										1.092
									],
									[
										-0.392,
										1.135
									],
									[
										-0.262,
										1.164
									],
									[
										-0.133,
										1.179
									],
									[
										-0.011,
										1.183
									]
								],
								v: [
									[
										-17.135,
										5.843
									],
									[
										-14.625,
										3.447
									],
									[
										-12.512,
										0.695
									],
									[
										-10.224,
										-1.93
									],
									[
										-8.905,
										-5.198
									],
									[
										-7.005,
										-8.083
									],
									[
										-5.519,
										-11.198
									],
									[
										-3.93,
										-14.277
									],
									[
										-2.726,
										-17.525
									],
									[
										-1.828,
										-20.872
									],
									[
										-0.594,
										-24.139
									],
									[
										-0.141,
										-27.697
									],
									[
										1.318,
										-30.956
									],
									[
										3.444,
										-33.809
									],
									[
										5.688,
										-36.507
									],
									[
										8.184,
										-39.059
									],
									[
										11.562,
										-40.227
									],
									[
										14.796,
										-41.659
									],
									[
										18.335,
										-41.667
									],
									[
										21.809,
										-41.441
									],
									[
										25.257,
										-40.833
									],
									[
										28.78,
										-40.012
									],
									[
										31.763,
										-37.971
									],
									[
										34.32,
										-35.426
									],
									[
										35.957,
										-32.241
									],
									[
										36.88,
										-28.87
									],
									[
										37.316,
										-25.424
									],
									[
										36.94,
										-21.93
									],
									[
										36.08,
										-18.448
									],
									[
										33.997,
										-15.525
									],
									[
										31.672,
										-12.863
									],
									[
										29.454,
										-10.111
									],
									[
										27.007,
										-7.523
									],
									[
										24.163,
										-5.381
									],
									[
										21.302,
										-3.259
									],
									[
										18.695,
										-0.827
									],
									[
										16.119,
										1.648
									],
									[
										14.053,
										4.569
									],
									[
										11.931,
										7.443
									],
									[
										10.694,
										10.809
									],
									[
										9.308,
										14.053
									],
									[
										8.487,
										17.479
									],
									[
										7,
										21.691
									],
									[
										6.557,
										26.016
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								0.722000002394,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 3.997,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								47.35,
								56.24
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 7",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 7,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										-1.363
									],
									[
										0.13,
										-1.329
									],
									[
										0.259,
										-1.312
									],
									[
										0.389,
										-1.283
									],
									[
										0.514,
										-1.24
									],
									[
										0.635,
										-1.187
									],
									[
										0.749,
										-1.12
									],
									[
										0.855,
										-1.041
									],
									[
										0.953,
										-0.953
									],
									[
										1.043,
										-0.856
									],
									[
										1.122,
										-0.751
									],
									[
										1.192,
										-0.639
									],
									[
										1.25,
										-0.519
									],
									[
										1.298,
										-0.393
									],
									[
										1.333,
										-0.263
									],
									[
										1.353,
										-0.132
									],
									[
										1.362,
										0
									],
									[
										1.329,
										0.129
									],
									[
										1.313,
										0.259
									],
									[
										1.283,
										0.389
									],
									[
										1.238,
										0.515
									],
									[
										1.185,
										0.633
									],
									[
										1.118,
										0.749
									],
									[
										1.041,
										0.854
									],
									[
										0.954,
										0.953
									],
									[
										0.858,
										1.043
									],
									[
										0.751,
										1.123
									],
									[
										0.638,
										1.191
									],
									[
										0.518,
										1.251
									],
									[
										0.394,
										1.298
									],
									[
										0.263,
										1.332
									],
									[
										0.132,
										1.354
									],
									[
										0,
										1.362
									],
									[
										-0.129,
										1.33
									],
									[
										-0.261,
										1.311
									],
									[
										-0.389,
										1.284
									],
									[
										-0.514,
										1.24
									],
									[
										-0.636,
										1.184
									],
									[
										-0.749,
										1.117
									],
									[
										-0.856,
										1.04
									],
									[
										-0.953,
										0.952
									],
									[
										-1.042,
										0.857
									],
									[
										-1.123,
										0.751
									],
									[
										-1.193,
										0.638
									],
									[
										-1.251,
										0.518
									],
									[
										-1.298,
										0.393
									],
									[
										-1.331,
										0.265
									],
									[
										-1.354,
										0.132
									],
									[
										-1.364,
										0
									],
									[
										-1.33,
										-0.129
									],
									[
										-1.311,
										-0.26
									],
									[
										-1.283,
										-0.39
									],
									[
										-1.24,
										-0.513
									],
									[
										-1.184,
										-0.635
									],
									[
										-1.118,
										-0.749
									],
									[
										-1.04,
										-0.855
									],
									[
										-0.954,
										-0.952
									],
									[
										-0.857,
										-1.043
									],
									[
										-0.751,
										-1.123
									],
									[
										-0.638,
										-1.192
									],
									[
										-0.518,
										-1.25
									],
									[
										-0.393,
										-1.298
									],
									[
										-0.263,
										-1.332
									],
									[
										-0.133,
										-1.354
									]
								],
								o: [
									[
										0,
										1.362
									],
									[
										-0.132,
										1.355
									],
									[
										-0.264,
										1.333
									],
									[
										-0.393,
										1.298
									],
									[
										-0.519,
										1.251
									],
									[
										-0.638,
										1.191
									],
									[
										-0.752,
										1.121
									],
									[
										-0.857,
										1.043
									],
									[
										-0.954,
										0.952
									],
									[
										-1.041,
										0.856
									],
									[
										-1.118,
										0.75
									],
									[
										-1.185,
										0.634
									],
									[
										-1.24,
										0.514
									],
									[
										-1.282,
										0.388
									],
									[
										-1.313,
										0.259
									],
									[
										-1.33,
										0.129
									],
									[
										-1.364,
										0
									],
									[
										-1.355,
										-0.132
									],
									[
										-1.332,
										-0.264
									],
									[
										-1.297,
										-0.393
									],
									[
										-1.252,
										-0.517
									],
									[
										-1.192,
										-0.639
									],
									[
										-1.122,
										-0.752
									],
									[
										-1.043,
										-0.858
									],
									[
										-0.953,
										-0.954
									],
									[
										-0.854,
										-1.04
									],
									[
										-0.748,
										-1.119
									],
									[
										-0.635,
										-1.186
									],
									[
										-0.515,
										-1.24
									],
									[
										-0.387,
										-1.282
									],
									[
										-0.26,
										-1.313
									],
									[
										-0.129,
										-1.33
									],
									[
										0,
										-1.363
									],
									[
										0.132,
										-1.354
									],
									[
										0.263,
										-1.333
									],
									[
										0.392,
										-1.296
									],
									[
										0.518,
										-1.25
									],
									[
										0.639,
										-1.193
									],
									[
										0.751,
										-1.123
									],
									[
										0.856,
										-1.043
									],
									[
										0.955,
										-0.953
									],
									[
										1.042,
										-0.854
									],
									[
										1.118,
										-0.748
									],
									[
										1.184,
										-0.635
									],
									[
										1.238,
										-0.515
									],
									[
										1.283,
										-0.389
									],
									[
										1.313,
										-0.259
									],
									[
										1.329,
										-0.129
									],
									[
										1.362,
										0
									],
									[
										1.355,
										0.133
									],
									[
										1.332,
										0.264
									],
									[
										1.298,
										0.393
									],
									[
										1.251,
										0.519
									],
									[
										1.192,
										0.639
									],
									[
										1.123,
										0.752
									],
									[
										1.043,
										0.857
									],
									[
										0.954,
										0.953
									],
									[
										0.854,
										1.041
									],
									[
										0.748,
										1.117
									],
									[
										0.635,
										1.186
									],
									[
										0.514,
										1.24
									],
									[
										0.388,
										1.282
									],
									[
										0.26,
										1.313
									],
									[
										0.129,
										1.329
									]
								],
								v: [
									[
										41.368,
										0.158
									],
									[
										41.106,
										4.186
									],
									[
										40.299,
										8.133
									],
									[
										39.535,
										12.087
									],
									[
										38.231,
										15.906
									],
									[
										36.464,
										19.538
									],
									[
										34.404,
										23.008
									],
									[
										32.217,
										26.426
									],
									[
										29.346,
										29.296
									],
									[
										26.249,
										31.889
									],
									[
										23.313,
										34.736
									],
									[
										19.455,
										36.167
									],
									[
										16.031,
										38.354
									],
									[
										12.07,
										39.257
									],
									[
										8.264,
										40.645
									],
									[
										4.212,
										40.775
									],
									[
										0.21,
										41.057
									],
									[
										-3.834,
										41.204
									],
									[
										-7.868,
										40.76
									],
									[
										-11.697,
										39.402
									],
									[
										-15.632,
										38.4
									],
									[
										-19.11,
										36.301
									],
									[
										-22.811,
										34.605
									],
									[
										-25.857,
										31.917
									],
									[
										-29.12,
										29.484
									],
									[
										-31.476,
										26.156
									],
									[
										-34.213,
										23.156
									],
									[
										-36.304,
										19.674
									],
									[
										-37.675,
										15.848
									],
									[
										-39.475,
										12.195
									],
									[
										-40.226,
										8.202
									],
									[
										-40.881,
										4.206
									],
									[
										-41.368,
										0.158
									],
									[
										-40.562,
										-3.86
									],
									[
										-40.176,
										-7.876
									],
									[
										-39.612,
										-11.924
									],
									[
										-38.228,
										-15.766
									],
									[
										-35.843,
										-19.113
									],
									[
										-33.821,
										-22.581
									],
									[
										-31.705,
										-26.035
									],
									[
										-28.985,
										-29.037
									],
									[
										-25.929,
										-31.694
									],
									[
										-22.666,
										-34.08
									],
									[
										-19.115,
										-35.999
									],
									[
										-15.699,
										-38.252
									],
									[
										-11.686,
										-39.055
									],
									[
										-7.84,
										-40.298
									],
									[
										-3.843,
										-40.977
									],
									[
										0.21,
										-40.75
									],
									[
										4.284,
										-41.204
									],
									[
										8.316,
										-40.597
									],
									[
										12.164,
										-39.249
									],
									[
										15.921,
										-37.773
									],
									[
										19.764,
										-36.425
									],
									[
										23.056,
										-34.035
									],
									[
										26.148,
										-31.449
									],
									[
										29.26,
										-28.892
									],
									[
										32.328,
										-26.199
									],
									[
										34.669,
										-22.865
									],
									[
										36.558,
										-19.271
									],
									[
										38.555,
										-15.726
									],
									[
										40.029,
										-11.921
									],
									[
										40.482,
										-7.855
									],
									[
										40.906,
										-3.852
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.804000016755,
								0.866999966491,
								0.2,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								67.13,
								43.158
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 8",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 8,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "ear shad",
		parent: 5,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.454
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.275
							],
							y: [
								0
							]
						},
						t: 19,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 35,
						s: [
							-32
						]
					},
					{
						t: 45,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.454,
							y: 1
						},
						o: {
							x: 0.275,
							y: 0
						},
						t: 19,
						s: [
							33.859,
							75.352,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-8.706,
							5.791,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 35,
						s: [
							64.317,
							71.761,
							0
						],
						to: [
							-11.524,
							6.319,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 45,
						s: [
							33.859,
							75.352,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					33.859,
					75.352,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										11.767,
										11.942
									],
									[
										-23.426,
										6.282
									]
								],
								o: [
									[
										7.264,
										11.072
									],
									[
										-17.754,
										1.868
									]
								],
								v: [
									[
										-23.779,
										-10.873
									],
									[
										23.779,
										4.591
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.579999976065,
								0.211999990426,
								0.556999954523,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								35.954,
								72.488
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "ear",
		parent: 13,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1.006
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 1,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.452
							],
							y: [
								-0.824
							]
						},
						o: {
							x: [
								0.234
							],
							y: [
								0
							]
						},
						t: 5,
						s: [
							-10.919
						]
					},
					{
						i: {
							x: [
								0.543
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.228
							],
							y: [
								0.217
							]
						},
						t: 7,
						s: [
							-10.293
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 10,
						s: [
							-7
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.133
							],
							y: [
								0
							]
						},
						t: 15,
						s: [
							-2
						]
					},
					{
						i: {
							x: [
								0.243
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.133
							],
							y: [
								0
							]
						},
						t: 16,
						s: [
							-2
						]
					},
					{
						i: {
							x: [
								0.655
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.589
							],
							y: [
								0
							]
						},
						t: 29,
						s: [
							34
						]
					},
					{
						i: {
							x: [
								0.523
							],
							y: [
								1.006
							]
						},
						o: {
							x: [
								0.702
							],
							y: [
								-0.009
							]
						},
						t: 34,
						s: [
							40
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 45,
						s: [
							-8
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 52,
						s: [
							1
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0
							]
						},
						t: 57,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.489
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.593
							],
							y: [
								-0.036
							]
						},
						t: 61,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 75,
						s: [
							-12
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 81,
						s: [
							-10
						]
					},
					{
						t: 99,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.325,
							y: 1
						},
						o: {
							x: 0.303,
							y: 0
						},
						t: 16,
						s: [
							98.144,
							14.758,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-0.533,
							0.093,
							0
						]
					},
					{
						i: {
							x: 0.833,
							y: 1
						},
						o: {
							x: 0.579,
							y: 0
						},
						t: 31,
						s: [
							96.577,
							17.41,
							0
						],
						to: [
							1.375,
							-0.239,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.827,
							y: 1
						},
						o: {
							x: 0.303,
							y: 0
						},
						t: 43,
						s: [
							98.144,
							14.758,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							4.234,
							-0.737,
							0
						]
					},
					{
						i: {
							x: 0.489,
							y: 1
						},
						o: {
							x: 0.593,
							y: 0.029
						},
						t: 61,
						s: [
							98.144,
							14.758,
							0
						],
						to: [
							-5.877,
							1.023,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 0.667
						},
						o: {
							x: 0.333,
							y: 0.333
						},
						t: 75,
						s: [
							86.772,
							23.746,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 81,
						s: [
							86.772,
							23.746,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-5.791,
							0.637,
							0
						]
					},
					{
						t: 99,
						s: [
							98.144,
							14.758,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					92.354,
					31.042,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.348,
								0.348,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 61,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 78,
						s: [
							90,
							100,
							100
						]
					},
					{
						t: 99,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 12,
									s: [
										{
											i: [
												[
													-6.92,
													20.878
												],
												[
													41.603,
													5.062
												]
											],
											o: [
												[
													-35.962,
													-30.669
												],
												[
													41.688,
													32.706
												]
											],
											v: [
												[
													45.967,
													-5.455
												],
												[
													-45.967,
													3.418
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 18,
									s: [
										{
											i: [
												[
													-13.29,
													13.981
												],
												[
													24.966,
													-12.599
												]
											],
											o: [
												[
													-30.328,
													-13.923
												],
												[
													43.002,
													15.643
												]
											],
											v: [
												[
													45.967,
													-5.455
												],
												[
													-43.1,
													12.893
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 35,
									s: [
										{
											i: [
												[
													-10.505,
													22.114
												],
												[
													26.761,
													15.303
												]
											],
											o: [
												[
													-30.976,
													-24.197
												],
												[
													27.152,
													40.61
												]
											],
											v: [
												[
													45.967,
													-5.455
												],
												[
													-45.114,
													-5.503
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 39,
									s: [
										{
											i: [
												[
													-15.206,
													27.269
												],
												[
													26.761,
													15.303
												]
											],
											o: [
												[
													-29.366,
													-17.853
												],
												[
													20.85,
													47.178
												]
											],
											v: [
												[
													45.967,
													-5.455
												],
												[
													-43.095,
													-10.219
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 48,
									s: [
										{
											i: [
												[
													-12.396,
													22.51
												],
												[
													36.049,
													-5.695
												]
											],
											o: [
												[
													-33.755,
													-26.24
												],
												[
													45.575,
													20.985
												]
											],
											v: [
												[
													45.967,
													-5.455
												],
												[
													-45.182,
													9.18
												]
											],
											c: true
										}
									]
								},
								{
									t: 55,
									s: [
										{
											i: [
												[
													-6.92,
													20.878
												],
												[
													41.603,
													5.062
												]
											],
											o: [
												[
													-35.962,
													-30.669
												],
												[
													41.688,
													32.706
												]
											],
											v: [
												[
													45.967,
													-5.455
												],
												[
													-45.967,
													3.418
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.579999976065,
								0.211999990426,
								0.556999954523,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								46.217,
								36.374
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 12,
									s: [
										{
											i: [
												[
													6.092,
													52.431
												],
												[
													31.868,
													11.373
												]
											],
											o: [
												[
													-27.983,
													-10.468
												],
												[
													19.593,
													60.862
												]
											],
											v: [
												[
													42.921,
													-29.634
												],
												[
													-49.013,
													-20.761
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 18,
									s: [
										{
											i: [
												[
													-3.537,
													52.936
												],
												[
													31.868,
													11.373
												]
											],
											o: [
												[
													-27.983,
													-10.468
												],
												[
													24.358,
													44.021
												]
											],
											v: [
												[
													42.921,
													-29.634
												],
												[
													-46.146,
													-11.285
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 35,
									s: [
										{
											i: [
												[
													6.092,
													52.431
												],
												[
													22.194,
													19.105
												]
											],
											o: [
												[
													-27.983,
													-10.468
												],
												[
													19.593,
													60.862
												]
											],
											v: [
												[
													42.921,
													-29.634
												],
												[
													-48.16,
													-29.682
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 39,
									s: [
										{
											i: [
												[
													3.398,
													53.778
												],
												[
													22.194,
													19.105
												]
											],
											o: [
												[
													-27.983,
													-10.468
												],
												[
													7.594,
													70.834
												]
											],
											v: [
												[
													42.921,
													-29.634
												],
												[
													-46.141,
													-34.397
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 48,
									s: [
										{
											i: [
												[
													6.092,
													52.431
												],
												[
													31.868,
													11.373
												]
											],
											o: [
												[
													-27.983,
													-10.468
												],
												[
													25.284,
													52.238
												]
											],
											v: [
												[
													42.921,
													-29.634
												],
												[
													-48.228,
													-14.999
												]
											],
											c: true
										}
									]
								},
								{
									t: 55,
									s: [
										{
											i: [
												[
													6.092,
													52.431
												],
												[
													31.868,
													11.373
												]
											],
											o: [
												[
													-27.983,
													-10.468
												],
												[
													19.593,
													60.862
												]
											],
											v: [
												[
													42.921,
													-29.634
												],
												[
													-49.013,
													-20.761
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								0.808000033509,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								49.263,
								60.553
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 3",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "eyebrow",
		parent: 13,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 4,
						s: [
							131.851,
							28.339,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.351,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 14,
						s: [
							133.32,
							42.613,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.65,
							y: 1
						},
						o: {
							x: 0.625,
							y: 0
						},
						t: 27,
						s: [
							131.597,
							26.171,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.827,
							y: 1
						},
						o: {
							x: 0.38,
							y: 0
						},
						t: 45,
						s: [
							132.277,
							31.27,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.922,
							y: 1
						},
						o: {
							x: 0.679,
							y: 0
						},
						t: 61,
						s: [
							131.851,
							28.339,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.349,
							y: 0.567
						},
						o: {
							x: 0.208,
							y: 0
						},
						t: 68,
						s: [
							135.8,
							55.373,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.085,
							y: 1
						},
						t: 69,
						s: [
							137.616,
							63.272,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.614,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 72,
						s: [
							137.534,
							64.648,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 0.667
						},
						o: {
							x: 0.333,
							y: 0.333
						},
						t: 79,
						s: [
							136.797,
							61.112,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.063,
							y: 0.987
						},
						o: {
							x: 0.377,
							y: 0
						},
						t: 83,
						s: [
							136.797,
							61.112,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 105,
						s: [
							131.851,
							28.339,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					8.959,
					7.597,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 4,
									s: [
										{
											i: [
												[
													6.688,
													-4.904
												],
												[
													-0.489,
													-6.94
												]
											],
											o: [
												[
													3.08,
													-10.363
												],
												[
													-4.036,
													-2.128
												]
											],
											v: [
												[
													-8.709,
													5.984
												],
												[
													8.709,
													0.957
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.351,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 14,
									s: [
										{
											i: [
												[
													7.716,
													-3.593
												],
												[
													-3.017,
													-4.74
												]
											],
											o: [
												[
													3.814,
													-9.493
												],
												[
													-4.631,
													0.051
												]
											],
											v: [
												[
													-8.709,
													5.984
												],
												[
													8.709,
													0.957
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.732,
										y: 1
									},
									o: {
										x: 0.642,
										y: 0
									},
									t: 27,
									s: [
										{
											i: [
												[
													5.858,
													-5.857
												],
												[
													-3.263,
													-8.575
												]
											],
											o: [
												[
													3.08,
													-10.363
												],
												[
													-6.264,
													-3.191
												]
											],
											v: [
												[
													-8.709,
													5.984
												],
												[
													8.709,
													0.957
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 45,
									s: [
										{
											i: [
												[
													6.688,
													-4.904
												],
												[
													-2.089,
													-5.043
												]
											],
											o: [
												[
													3.154,
													-9.235
												],
												[
													-3.939,
													0.052
												]
											],
											v: [
												[
													-8.709,
													5.984
												],
												[
													8.709,
													0.956
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.922,
										y: 1
									},
									o: {
										x: 0.679,
										y: 0
									},
									t: 61,
									s: [
										{
											i: [
												[
													6.688,
													-4.904
												],
												[
													-0.489,
													-6.94
												]
											],
											o: [
												[
													3.08,
													-10.363
												],
												[
													-4.036,
													-2.128
												]
											],
											v: [
												[
													-8.709,
													5.984
												],
												[
													8.709,
													0.957
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.113,
										y: 0
									},
									t: 68,
									s: [
										{
											i: [
												[
													7.148,
													0.15
												],
												[
													-3.813,
													-1.986
												]
											],
											o: [
												[
													3.653,
													-3.936
												],
												[
													-2.486,
													2.39
												]
											],
											v: [
												[
													-8.777,
													3.602
												],
												[
													8.655,
													-0.601
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 72,
									s: [
										{
											i: [
												[
													7.474,
													6.347
												],
												[
													-5.31,
													2.688
												]
											],
											o: [
												[
													6.862,
													0.001
												],
												[
													-1.253,
													5.688
												]
											],
											v: [
												[
													-8.826,
													1.765
												],
												[
													8.622,
													-1.557
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 79,
									s: [
										{
											i: [
												[
													8.151,
													4.668
												],
												[
													-4.99,
													2.093
												]
											],
											o: [
												[
													6.646,
													-0.292
												],
												[
													-1.392,
													5.287
												]
											],
											v: [
												[
													-8.826,
													1.765
												],
												[
													8.622,
													-1.557
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.258,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 83,
									s: [
										{
											i: [
												[
													8.151,
													4.668
												],
												[
													-4.99,
													2.093
												]
											],
											o: [
												[
													6.646,
													-0.292
												],
												[
													-1.392,
													5.287
												]
											],
											v: [
												[
													-8.826,
													1.765
												],
												[
													8.622,
													-1.557
												]
											],
											c: true
										}
									]
								},
								{
									t: 105,
									s: [
										{
											i: [
												[
													6.688,
													-4.904
												],
												[
													-0.489,
													-6.94
												]
											],
											o: [
												[
													3.08,
													-10.363
												],
												[
													-4.036,
													-2.128
												]
											],
											v: [
												[
													-8.709,
													5.984
												],
												[
													8.709,
													0.957
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.231000010173,
								0.067000003889,
								0.224000010771,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								8.959,
								6.234
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "eyelid",
		parent: 8,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 59,
						s: [
							-2.579
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 66,
						s: [
							1.421
						]
					},
					{
						t: 69,
						s: [
							-2.579
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 4,
						s: [
							4.839,
							16.499,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.557,
							y: 1
						},
						o: {
							x: 0.285,
							y: 0
						},
						t: 19,
						s: [
							3.879,
							12.48,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.699,
							y: 0.699
						},
						o: {
							x: 0.3,
							y: 0.3
						},
						t: 35,
						s: [
							4.839,
							16.499,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.554,
							y: 0
						},
						t: 59,
						s: [
							4.839,
							16.499,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.833,
							y: 0.833
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 66,
						s: [
							5.005,
							12.554,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 0.667
						},
						o: {
							x: 0.167,
							y: 0.167
						},
						t: 68,
						s: [
							5.381,
							12.015,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.177,
							y: 0
						},
						t: 86,
						s: [
							5.381,
							12.015,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 101,
						s: [
							3.055,
							16.748,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					85.25,
					84.25,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										75.313,
										80.125
									],
									[
										72.25,
										86.938
									],
									[
										91.5,
										87.563
									],
									[
										92.875,
										81.875
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								0.807843197093,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 4,
		op: 102,
		st: 66,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "eye",
		parent: 13,
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						t: 0,
						s: [
							100
						],
						h: 1
					},
					{
						t: 69,
						s: [
							0
						],
						h: 1
					},
					{
						t: 87,
						s: [
							100
						],
						h: 1
					}
				],
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 14,
						s: [
							2
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 26,
						s: [
							11
						]
					},
					{
						t: 40,
						s: [
							2
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.717,
							y: 0.016
						},
						o: {
							x: 0.403,
							y: 0
						},
						t: 49,
						s: [
							137.707,
							57.947,
							0
						],
						to: [
							1.256,
							0.806,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 0.667
						},
						o: {
							x: 0.333,
							y: 0.333
						},
						t: 68,
						s: [
							140.657,
							59.702,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 83,
						s: [
							140.657,
							59.702,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 101,
						s: [
							137.707,
							57.947,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					4.655,
					6.399,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 4,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													0.409,
													-2.153
												],
												[
													-0.409,
													2.153
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 13,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-0.077,
													-0.149
												],
												[
													-0.409,
													2.153
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 15,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													0,
													-0.465
												],
												[
													-0.409,
													2.153
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 25,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													0.409,
													-2.153
												],
												[
													-0.409,
													2.153
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 66,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													0.409,
													-2.153
												],
												[
													-0.409,
													2.153
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 68,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-0.587,
													2.253
												],
												[
													-0.409,
													2.153
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 84.223,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-0.587,
													2.253
												],
												[
													-0.409,
													2.153
												]
											],
											c: false
										}
									]
								},
								{
									t: 95,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													0.409,
													-2.153
												],
												[
													-0.409,
													2.153
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.231000010173,
								0.067000003889,
								0.224000010771,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8.493,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								4.655,
								6.399
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "mouth",
		parent: 13,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					161.359,
					98.532,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					35.807,
					13.498,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.564,
										y: 0
									},
									t: 4,
									s: [
										{
											i: [
												[
													-2.438,
													4.599
												],
												[
													-10.033,
													-5.905
												],
												[
													-11.672,
													0.427
												],
												[
													-3.118,
													12.442
												],
												[
													0.325,
													-1.383
												],
												[
													22.216,
													1.018
												],
												[
													5.389,
													3.475
												]
											],
											o: [
												[
													-0.005,
													3.059
												],
												[
													6.281,
													3.696
												],
												[
													13.747,
													-0.503
												],
												[
													0.384,
													0.724
												],
												[
													-1.542,
													6.555
												],
												[
													-10.74,
													-0.492
												],
												[
													-9.036,
													-5.826
												]
											],
											v: [
												[
													-32.327,
													-13.574
												],
												[
													-20.003,
													2.581
												],
												[
													8.565,
													9.841
												],
												[
													34.382,
													-13.735
												],
												[
													34.236,
													-9.688
												],
												[
													3.423,
													12.904
												],
												[
													-21.859,
													4.988
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 13,
									s: [
										{
											i: [
												[
													2.619,
													3.052
												],
												[
													-10.033,
													-5.905
												],
												[
													-11.672,
													0.427
												],
												[
													-3.118,
													12.442
												],
												[
													0.325,
													-1.383
												],
												[
													22.216,
													1.018
												],
												[
													5.389,
													3.475
												]
											],
											o: [
												[
													3.229,
													0.97
												],
												[
													6.281,
													3.696
												],
												[
													13.747,
													-0.503
												],
												[
													0.384,
													0.724
												],
												[
													-1.542,
													6.555
												],
												[
													-10.74,
													-0.492
												],
												[
													-9.036,
													-5.826
												]
											],
											v: [
												[
													-36.071,
													-5.189
												],
												[
													-20.402,
													2.862
												],
												[
													8.565,
													9.841
												],
												[
													34.382,
													-13.735
												],
												[
													34.236,
													-9.688
												],
												[
													3.423,
													12.904
												],
												[
													-21.859,
													4.988
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.429,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 18,
									s: [
										{
											i: [
												[
													2.619,
													3.052
												],
												[
													-10.033,
													-5.905
												],
												[
													-11.672,
													0.427
												],
												[
													-3.118,
													12.442
												],
												[
													0.325,
													-1.383
												],
												[
													22.216,
													1.018
												],
												[
													5.389,
													3.475
												]
											],
											o: [
												[
													3.229,
													0.97
												],
												[
													6.281,
													3.696
												],
												[
													13.747,
													-0.503
												],
												[
													0.384,
													0.724
												],
												[
													-1.542,
													6.555
												],
												[
													-10.74,
													-0.492
												],
												[
													-9.036,
													-5.826
												]
											],
											v: [
												[
													-36.071,
													-5.189
												],
												[
													-20.402,
													2.862
												],
												[
													8.565,
													9.841
												],
												[
													34.382,
													-13.735
												],
												[
													34.236,
													-9.688
												],
												[
													3.423,
													12.904
												],
												[
													-21.859,
													4.988
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 28,
									s: [
										{
											i: [
												[
													-2.438,
													4.599
												],
												[
													-10.033,
													-5.905
												],
												[
													-11.672,
													0.427
												],
												[
													-3.118,
													12.442
												],
												[
													0.325,
													-1.383
												],
												[
													22.216,
													1.018
												],
												[
													5.389,
													3.475
												]
											],
											o: [
												[
													-0.005,
													3.059
												],
												[
													6.281,
													3.696
												],
												[
													13.747,
													-0.503
												],
												[
													0.384,
													0.724
												],
												[
													-1.542,
													6.555
												],
												[
													-10.74,
													-0.492
												],
												[
													-9.036,
													-5.826
												]
											],
											v: [
												[
													-32.327,
													-13.574
												],
												[
													-20.003,
													2.581
												],
												[
													8.565,
													9.841
												],
												[
													34.382,
													-13.735
												],
												[
													34.236,
													-9.688
												],
												[
													3.423,
													12.904
												],
												[
													-21.859,
													4.988
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0,
										y: 1
									},
									o: {
										x: 0.49,
										y: 0
									},
									t: 62,
									s: [
										{
											i: [
												[
													-2.438,
													4.599
												],
												[
													-10.033,
													-5.905
												],
												[
													-11.672,
													0.427
												],
												[
													-3.118,
													12.442
												],
												[
													0.325,
													-1.383
												],
												[
													22.216,
													1.018
												],
												[
													5.389,
													3.475
												]
											],
											o: [
												[
													-0.005,
													3.059
												],
												[
													6.281,
													3.696
												],
												[
													13.747,
													-0.503
												],
												[
													0.384,
													0.724
												],
												[
													-1.542,
													6.555
												],
												[
													-10.74,
													-0.492
												],
												[
													-9.036,
													-5.826
												]
											],
											v: [
												[
													-32.327,
													-13.574
												],
												[
													-20.003,
													2.581
												],
												[
													8.565,
													9.841
												],
												[
													34.382,
													-13.735
												],
												[
													34.236,
													-9.688
												],
												[
													3.423,
													12.904
												],
												[
													-21.859,
													4.988
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.552,
										y: 0
									},
									t: 79,
									s: [
										{
											i: [
												[
													0.993,
													5.51
												],
												[
													-11.332,
													-2.794
												],
												[
													-12.276,
													2.119
												],
												[
													-1.748,
													9.639
												],
												[
													0.172,
													-1.068
												],
												[
													24.802,
													-2.843
												],
												[
													6.105,
													1.967
												]
											],
											o: [
												[
													2.571,
													2.533
												],
												[
													7.094,
													1.749
												],
												[
													14.458,
													-2.495
												],
												[
													0.496,
													0.473
												],
												[
													-0.814,
													5.063
												],
												[
													-11.405,
													1.307
												],
												[
													-10.129,
													-3.263
												]
											],
											v: [
												[
													-37.847,
													-11.698
												],
												[
													-20.968,
													-1.787
												],
												[
													10.109,
													-0.86
												],
												[
													34.45,
													-22.202
												],
												[
													34.798,
													-19.201
												],
												[
													5.375,
													2.562
												],
												[
													-22.468,
													0.486
												]
											],
											c: true
										}
									]
								},
								{
									t: 102,
									s: [
										{
											i: [
												[
													-2.438,
													4.599
												],
												[
													-10.033,
													-5.905
												],
												[
													-11.672,
													0.427
												],
												[
													-3.118,
													12.442
												],
												[
													0.325,
													-1.383
												],
												[
													22.216,
													1.018
												],
												[
													5.389,
													3.475
												]
											],
											o: [
												[
													-0.005,
													3.059
												],
												[
													6.281,
													3.696
												],
												[
													13.747,
													-0.503
												],
												[
													0.384,
													0.724
												],
												[
													-1.542,
													6.555
												],
												[
													-10.74,
													-0.492
												],
												[
													-9.036,
													-5.826
												]
											],
											v: [
												[
													-32.327,
													-13.574
												],
												[
													-20.003,
													2.581
												],
												[
													8.565,
													9.841
												],
												[
													34.382,
													-13.735
												],
												[
													34.236,
													-9.688
												],
												[
													3.423,
													12.904
												],
												[
													-21.859,
													4.988
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.231000010173,
								0.067000003889,
								0.224000010771,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								35.015,
								13.985
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 4,
		nm: "whisker dots",
		parent: 13,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 10,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 15,
						s: [
							19
						]
					},
					{
						i: {
							x: [
								0.686
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 25,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.133
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.46
							],
							y: [
								0
							]
						},
						t: 62,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.596
							],
							y: [
								0
							]
						},
						t: 79,
						s: [
							-6
						]
					},
					{
						t: 102,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 10,
						s: [
							171.376,
							90.658,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 15,
						s: [
							169.77,
							95.924,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.717,
							y: 0.717
						},
						o: {
							x: 0.333,
							y: 0.333
						},
						t: 25,
						s: [
							171.376,
							90.658,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.133,
							y: 1
						},
						o: {
							x: 0.46,
							y: 0
						},
						t: 62,
						s: [
							171.376,
							90.658,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.596,
							y: 0
						},
						t: 79,
						s: [
							170,
							83.261,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 102,
						s: [
							171.376,
							90.658,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					11.918,
					8.067,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.133,
								0.133,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.46,
								0.46,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 62,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.596,
								0.596,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 79,
						s: [
							100,
							85,
							100
						]
					},
					{
						t: 102,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-2.68,
										1.273
									],
									[
										2.632,
										-1.491
									]
								],
								o: [
									[
										2.607,
										-1.239
									],
									[
										-2.633,
										1.49
									]
								],
								v: [
									[
										1.059,
										1.967
									],
									[
										-1.033,
										-1.75
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.579999976065,
								0.211999990426,
								0.556999954523,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								13.711,
								12.761
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-2.376,
										0.124
									],
									[
										3.185,
										0.06
									]
								],
								o: [
									[
										3.006,
										-0.156
									],
									[
										-3.186,
										-0.06
									]
								],
								v: [
									[
										-0.299,
										1.967
									],
									[
										0.001,
										-2.031
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.579999976065,
								0.211999990426,
								0.556999954523,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								9.317,
								3.164
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-2.769,
										1.238
									],
									[
										3.29,
										-1.78
									]
								],
								o: [
									[
										3.537,
										-1.583
									],
									[
										-3.718,
										2.01
									]
								],
								v: [
									[
										1.172,
										2.794
									],
									[
										-0.991,
										-2.252
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.579999976065,
								0.211999990426,
								0.556999954523,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								19.454,
								4.282
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 3",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										1.443,
										-1.258
									],
									[
										-1.073,
										0.661
									]
								],
								o: [
									[
										-2.025,
										1.764
									],
									[
										1.768,
										-1.087
									]
								],
								v: [
									[
										-0.534,
										-0.943
									],
									[
										0.792,
										1.54
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.579999976065,
								0.211999990426,
								0.556999954523,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								2.81,
								12.093
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 4",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 4,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "nose",
		parent: 13,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 10,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 15,
						s: [
							32
						]
					},
					{
						i: {
							x: [
								0.686
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 25,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.405
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.603
							],
							y: [
								0
							]
						},
						t: 61,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 75,
						s: [
							-16
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 81,
						s: [
							-16
						]
					},
					{
						t: 102,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 10,
						s: [
							190.321,
							73.649,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 15,
						s: [
							191.801,
							89.144,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.717,
							y: 0.717
						},
						o: {
							x: 0.333,
							y: 0.333
						},
						t: 25,
						s: [
							190.321,
							73.649,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.405,
							y: 1
						},
						o: {
							x: 0.603,
							y: 0
						},
						t: 61,
						s: [
							190.321,
							73.649,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							3.034,
							2.331,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 75,
						s: [
							187.154,
							66.817,
							0
						],
						to: [
							-0.058,
							-0.001,
							0
						],
						ti: [
							-0.069,
							-0.017,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 81,
						s: [
							187.154,
							66.817,
							0
						],
						to: [
							3.241,
							2.421,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 102,
						s: [
							190.321,
							73.649,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					11.046,
					9.448,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-9.974,
										3.051
									],
									[
										18.213,
										-0.899
									]
								],
								o: [
									[
										1.283,
										-14.653
									],
									[
										-0.258,
										13.838
									]
								],
								v: [
									[
										9.917,
										6.885
									],
									[
										-10.942,
										-9.038
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.231000010173,
								0.067000003889,
								0.224000010771,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								11.45,
								10.187
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 4,
		nm: "collar",
		parent: 13,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.666
							],
							y: [
								0
							]
						},
						t: 2,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.471
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.361
							],
							y: [
								0
							]
						},
						t: 13,
						s: [
							13
						]
					},
					{
						i: {
							x: [
								0.62
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.24
							],
							y: [
								0
							]
						},
						t: 30,
						s: [
							-18.539
						]
					},
					{
						t: 42,
						s: [
							1
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.723,
							y: 0.866
						},
						o: {
							x: 0.452,
							y: 0
						},
						t: 9,
						s: [
							58.004,
							33.627,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.546,
							y: 1
						},
						o: {
							x: 0.408,
							y: 0.103
						},
						t: 33,
						s: [
							38.189,
							36.95,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 41,
						s: [
							58.004,
							33.627,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					58.004,
					33.627,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 11,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-7.699,
													-34.974
												]
											],
											o: [
												[
													-5.764,
													36.717
												],
												[
													4.492,
													20.407
												]
											],
											v: [
												[
													10.042,
													-40.922
												],
												[
													11.779,
													45.014
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 12,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-8.177,
													-37.311
												]
											],
											o: [
												[
													-5.764,
													36.717
												],
												[
													4.473,
													20.411
												]
											],
											v: [
												[
													10.042,
													-40.922
												],
												[
													13.317,
													53.029
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 16,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-9.65,
													-37.029
												]
											],
											o: [
												[
													-5.764,
													36.717
												],
												[
													5.27,
													20.22
												]
											],
											v: [
												[
													10.042,
													-40.922
												],
												[
													15.983,
													68.855
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.754,
										y: 0
									},
									t: 26,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-9.65,
													-37.029
												]
											],
											o: [
												[
													-5.764,
													36.717
												],
												[
													5.27,
													20.22
												]
											],
											v: [
												[
													10.042,
													-40.922
												],
												[
													15.983,
													68.855
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 33,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-3.463,
													-37.881
												]
											],
											o: [
												[
													3.226,
													36.624
												],
												[
													1.891,
													20.646
												]
											],
											v: [
												[
													4.969,
													-40.233
												],
												[
													15.831,
													69.511
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 37,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-9.65,
													-37.029
												]
											],
											o: [
												[
													-5.764,
													36.717
												],
												[
													5.27,
													20.22
												]
											],
											v: [
												[
													10.042,
													-40.922
												],
												[
													15.983,
													68.855
												]
											],
											c: false
										}
									]
								},
								{
									t: 38,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-7.699,
													-34.974
												]
											],
											o: [
												[
													-5.764,
													36.717
												],
												[
													4.492,
													20.407
												]
											],
											v: [
												[
													10.042,
													-40.922
												],
												[
													11.779,
													45.014
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.976000019148,
								0.957000014361,
								0.976000019148,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 4.491,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								56.314,
								71.844
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 11,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-8.601,
													-34.162
												]
											],
											o: [
												[
													-5.765,
													36.717
												],
												[
													3.689,
													14.652
												]
											],
											v: [
												[
													9.982,
													-40.408
												],
												[
													12.393,
													46.468
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 12,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-9.05,
													-44.325
												]
											],
											o: [
												[
													-5.765,
													36.717
												],
												[
													3.022,
													14.804
												]
											],
											v: [
												[
													9.982,
													-40.408
												],
												[
													13.252,
													55.076
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 16,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-11.16,
													-45.517
												]
											],
											o: [
												[
													-5.765,
													36.717
												],
												[
													3.598,
													14.674
												]
											],
											v: [
												[
													9.982,
													-40.408
												],
												[
													15.918,
													70.901
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.754,
										y: 0
									},
									t: 26,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-11.16,
													-45.517
												]
											],
											o: [
												[
													-5.765,
													36.717
												],
												[
													3.598,
													14.674
												]
											],
											v: [
												[
													9.982,
													-40.408
												],
												[
													15.918,
													70.901
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 33,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-5.245,
													-44.084
												]
											],
											o: [
												[
													3.055,
													36.407
												],
												[
													1.721,
													14.94
												]
											],
											v: [
												[
													5.236,
													-37.876
												],
												[
													15.918,
													70.901
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 37,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-11.16,
													-45.517
												]
											],
											o: [
												[
													-5.765,
													36.717
												],
												[
													3.598,
													14.674
												]
											],
											v: [
												[
													9.982,
													-40.408
												],
												[
													15.918,
													70.901
												]
											],
											c: false
										}
									]
								},
								{
									t: 38,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-8.601,
													-34.162
												]
											],
											o: [
												[
													-5.765,
													36.717
												],
												[
													3.689,
													14.652
												]
											],
											v: [
												[
													9.982,
													-40.408
												],
												[
													12.393,
													46.468
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.579999976065,
								0.211999990426,
								0.556999954523,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 16.987,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								49.128,
								71.111
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "head",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.815
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.473
							],
							y: [
								0
							]
						},
						t: 0.771,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.69
							],
							y: [
								0.386
							]
						},
						o: {
							x: [
								0.531
							],
							y: [
								0
							]
						},
						t: 8,
						s: [
							14
						]
					},
					{
						i: {
							x: [
								0.44
							],
							y: [
								0.61
							]
						},
						o: {
							x: [
								0.3
							],
							y: [
								0.371
							]
						},
						t: 12,
						s: [
							1.393
						]
					},
					{
						i: {
							x: [
								0.146
							],
							y: [
								1.001
							]
						},
						o: {
							x: [
								0.196
							],
							y: [
								0.329
							]
						},
						t: 16,
						s: [
							-17.941
						]
					},
					{
						i: {
							x: [
								0.705
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.559
							],
							y: [
								0.001
							]
						},
						t: 25,
						s: [
							-36
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.48
							],
							y: [
								-0.013
							]
						},
						t: 44.098,
						s: [
							1
						]
					},
					{
						i: {
							x: [
								0.583
							],
							y: [
								0.996
							]
						},
						o: {
							x: [
								0.48
							],
							y: [
								0
							]
						},
						t: 53.269,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.547
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.448
							],
							y: [
								0
							]
						},
						t: 68,
						s: [
							5
						]
					},
					{
						i: {
							x: [
								0.547
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.667
							],
							y: [
								0
							]
						},
						t: 72,
						s: [
							6
						]
					},
					{
						i: {
							x: [
								0.377
							],
							y: [
								1.009
							]
						},
						o: {
							x: [
								0.667
							],
							y: [
								0
							]
						},
						t: 78,
						s: [
							6
						]
					},
					{
						t: 104.2138671875,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.663,
							y: 0.736
						},
						o: {
							x: 0.663,
							y: 0
						},
						t: 0,
						s: [
							-2.287,
							88.192,
							0
						],
						to: [
							13.662,
							-0.067,
							0
						],
						ti: [
							-13.93,
							-1.039,
							0
						]
					},
					{
						i: {
							x: 0.379,
							y: 0.747
						},
						o: {
							x: 0.226,
							y: 0.097
						},
						t: 12,
						s: [
							27.761,
							103.147,
							0
						],
						to: [
							23.743,
							-0.782,
							0
						],
						ti: [
							23.971,
							-0.558,
							0
						]
					},
					{
						i: {
							x: 0.559,
							y: 0.811
						},
						o: {
							x: 0.551,
							y: 0.236
						},
						t: 26,
						s: [
							41.963,
							49.064,
							0
						],
						to: [
							-27.831,
							2.229,
							0
						],
						ti: [
							13.033,
							0.927,
							0
						]
					},
					{
						i: {
							x: 0.637,
							y: 0.952
						},
						o: {
							x: 0.307,
							y: 0.508
						},
						t: 40,
						s: [
							0.14,
							93.662,
							0
						],
						to: [
							-4.221,
							-0.165,
							0
						],
						ti: [
							0.011,
							1.386,
							0
						]
					},
					{
						i: {
							x: 0.611,
							y: 1
						},
						o: {
							x: 0.285,
							y: 0.107
						},
						t: 47,
						s: [
							-6.638,
							90.492,
							0
						],
						to: [
							-0.01,
							-1.205,
							0
						],
						ti: [
							-2.271,
							0.097,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.659,
							y: 0
						},
						t: 63,
						s: [
							-2.287,
							88.192,
							0
						],
						to: [
							0.026,
							0.067,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 0.94
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 73,
						s: [
							-6.537,
							88.192,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0.147
						},
						t: 80,
						s: [
							-4.552,
							88.192,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 96,
						s: [
							-2.287,
							88.192,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					48.601,
					75.24,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 5,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-7.993,
													-5.953
												],
												[
													0.296,
													-10.355
												],
												[
													0,
													0
												],
												[
													-20.654,
													0.681
												],
												[
													-2.033,
													-11.419
												],
												[
													43.082,
													-0.658
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													24.542,
													-6.973
												],
												[
													9.839,
													7.328
												],
												[
													-0.082,
													2.88
												],
												[
													0,
													0
												],
												[
													18.083,
													0.504
												],
												[
													-1.331,
													22.64
												],
												[
													-49.811,
													0.798
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-15.971,
													-71.475
												],
												[
													29.979,
													-72.516
												],
												[
													39.914,
													-30.241
												],
												[
													39.696,
													-25.583
												],
												[
													70.681,
													-21.64
												],
												[
													91.541,
													-5.717
												],
												[
													32.86,
													43.231
												],
												[
													-91.541,
													10.362
												],
												[
													-55.538,
													-49.752
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 10,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-7.993,
													-5.953
												],
												[
													0.296,
													-10.355
												],
												[
													0,
													0
												],
												[
													-20.654,
													0.681
												],
												[
													-2.033,
													-11.419
												],
												[
													43.082,
													-0.658
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													24.542,
													-6.973
												],
												[
													9.839,
													7.328
												],
												[
													-0.082,
													2.88
												],
												[
													0,
													0
												],
												[
													18.083,
													0.504
												],
												[
													-1.331,
													22.64
												],
												[
													-49.811,
													0.798
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-15.971,
													-71.475
												],
												[
													29.709,
													-68.886
												],
												[
													39.914,
													-30.241
												],
												[
													39.696,
													-25.583
												],
												[
													70.681,
													-21.64
												],
												[
													91.541,
													-5.717
												],
												[
													28.486,
													29.089
												],
												[
													-91.541,
													10.362
												],
												[
													-53.713,
													-53.093
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 15,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-6.602,
													-7.466
												],
												[
													0.296,
													-10.355
												],
												[
													0,
													0
												],
												[
													-17.28,
													-10.152
												],
												[
													1.488,
													-11.503
												],
												[
													29.672,
													8.029
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													24.929,
													-5.083
												],
												[
													8.313,
													9.4
												],
												[
													-0.082,
													2.88
												],
												[
													0,
													0
												],
												[
													9.651,
													5.669
												],
												[
													-10.141,
													23.545
												],
												[
													-48.088,
													-13.012
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-15.971,
													-71.475
												],
												[
													30.108,
													-62.935
												],
												[
													39.914,
													-30.241
												],
												[
													39.696,
													-25.583
												],
												[
													79.537,
													-9.542
												],
												[
													85.734,
													15.916
												],
												[
													25.703,
													43.435
												],
												[
													-91.541,
													10.362
												],
												[
													-82.305,
													-50.485
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 25,
									s: [
										{
											i: [
												[
													-30.591,
													25.437
												],
												[
													-7.993,
													-5.953
												],
												[
													0.184,
													-10.743
												],
												[
													0,
													0
												],
												[
													-20.654,
													0.681
												],
												[
													-2.033,
													-11.419
												],
												[
													43.082,
													-0.658
												],
												[
													0,
													0
												],
												[
													-39.186,
													18.741
												]
											],
											o: [
												[
													16.828,
													-13.993
												],
												[
													9.422,
													7.018
												],
												[
													-0.042,
													3.754
												],
												[
													0,
													0
												],
												[
													18.083,
													0.504
												],
												[
													-1.331,
													22.64
												],
												[
													-49.811,
													0.798
												],
												[
													0,
													0
												],
												[
													21.377,
													-10.223
												]
											],
											v: [
												[
													-14.98,
													-70.243
												],
												[
													31.573,
													-76.841
												],
												[
													39.927,
													-31.816
												],
												[
													39.696,
													-25.583
												],
												[
													70.681,
													-21.64
												],
												[
													91.541,
													-5.717
												],
												[
													32.86,
													43.231
												],
												[
													-91.541,
													10.362
												],
												[
													-84.007,
													-41.413
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 33,
									s: [
										{
											i: [
												[
													-38.019,
													11.72
												],
												[
													-7.993,
													-5.953
												],
												[
													0.184,
													-10.743
												],
												[
													0,
													0
												],
												[
													-20.654,
													0.681
												],
												[
													-2.033,
													-11.419
												],
												[
													43.082,
													-0.658
												],
												[
													0,
													0
												],
												[
													-39.186,
													18.741
												]
											],
											o: [
												[
													22.596,
													-6.965
												],
												[
													9.422,
													7.018
												],
												[
													-0.042,
													3.754
												],
												[
													0,
													0
												],
												[
													18.083,
													0.504
												],
												[
													-1.331,
													22.64
												],
												[
													-49.811,
													0.798
												],
												[
													0,
													0
												],
												[
													21.377,
													-10.223
												]
											],
											v: [
												[
													-16.006,
													-69.104
												],
												[
													29.979,
													-72.516
												],
												[
													39.927,
													-31.816
												],
												[
													39.696,
													-25.583
												],
												[
													70.681,
													-21.64
												],
												[
													91.541,
													-5.717
												],
												[
													32.86,
													43.231
												],
												[
													-91.541,
													10.362
												],
												[
													-84.007,
													-41.413
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 43,
									s: [
										{
											i: [
												[
													-38.019,
													11.72
												],
												[
													-7.993,
													-5.953
												],
												[
													0.184,
													-10.743
												],
												[
													0,
													0
												],
												[
													-20.654,
													0.681
												],
												[
													-2.033,
													-11.419
												],
												[
													43.082,
													-0.658
												],
												[
													0,
													0
												],
												[
													-39.186,
													18.741
												]
											],
											o: [
												[
													22.596,
													-6.965
												],
												[
													9.422,
													7.018
												],
												[
													-0.042,
													3.754
												],
												[
													0,
													0
												],
												[
													18.083,
													0.504
												],
												[
													-1.331,
													22.64
												],
												[
													-49.811,
													0.798
												],
												[
													0,
													0
												],
												[
													21.377,
													-10.223
												]
											],
											v: [
												[
													-15.971,
													-71.475
												],
												[
													29.979,
													-72.516
												],
												[
													39.927,
													-31.816
												],
												[
													39.696,
													-25.583
												],
												[
													70.681,
													-21.64
												],
												[
													91.541,
													-5.717
												],
												[
													32.86,
													43.231
												],
												[
													-91.541,
													10.362
												],
												[
													-84.007,
													-41.413
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.489,
										y: 1
									},
									o: {
										x: 0.603,
										y: 0
									},
									t: 61,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-7.993,
													-5.953
												],
												[
													-0.136,
													-11.851
												],
												[
													0,
													0
												],
												[
													-20.654,
													0.681
												],
												[
													-2.033,
													-11.419
												],
												[
													43.082,
													-0.658
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													24.542,
													-6.973
												],
												[
													8.233,
													6.132
												],
												[
													0.071,
													6.25
												],
												[
													0,
													0
												],
												[
													18.083,
													0.504
												],
												[
													-1.331,
													22.64
												],
												[
													-49.811,
													0.798
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-15.971,
													-71.475
												],
												[
													29.979,
													-72.516
												],
												[
													39.965,
													-36.312
												],
												[
													39.696,
													-25.583
												],
												[
													70.681,
													-21.64
												],
												[
													91.541,
													-5.717
												],
												[
													32.86,
													43.231
												],
												[
													-91.541,
													10.362
												],
												[
													-56.971,
													-74.374
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.489,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 75,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-8.841,
													-5.95
												],
												[
													-1.844,
													-11.044
												],
												[
													0,
													0
												],
												[
													-19.386,
													7.158
												],
												[
													-5.529,
													-10.196
												],
												[
													43.082,
													-0.658
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													16.525,
													-4.325
												],
												[
													10.813,
													7.277
												],
												[
													5.39,
													2.775
												],
												[
													0,
													0
												],
												[
													17.32,
													-5.223
												],
												[
													5.875,
													21.905
												],
												[
													-49.811,
													0.798
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-23.006,
													-63.069
												],
												[
													22.068,
													-65.274
												],
												[
													39.628,
													-32.219
												],
												[
													42.012,
													-25.072
												],
												[
													64.829,
													-25.122
												],
												[
													89.646,
													-16.588
												],
												[
													32.86,
													43.231
												],
												[
													-91.541,
													10.362
												],
												[
													-54.254,
													-43.74
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 81,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-8.841,
													-5.95
												],
												[
													-1.844,
													-11.044
												],
												[
													0,
													0
												],
												[
													-19.386,
													7.158
												],
												[
													-5.529,
													-10.196
												],
												[
													43.082,
													-0.658
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													16.525,
													-4.325
												],
												[
													10.813,
													7.277
												],
												[
													5.39,
													2.775
												],
												[
													0,
													0
												],
												[
													17.32,
													-5.223
												],
												[
													5.875,
													21.905
												],
												[
													-49.811,
													0.798
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-23.006,
													-63.069
												],
												[
													22.068,
													-65.274
												],
												[
													39.628,
													-32.219
												],
												[
													42.012,
													-25.072
												],
												[
													64.829,
													-25.122
												],
												[
													89.646,
													-16.588
												],
												[
													32.86,
													43.231
												],
												[
													-91.541,
													10.362
												],
												[
													-54.254,
													-43.74
												]
											],
											c: true
										}
									]
								},
								{
									t: 102,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-7.993,
													-5.953
												],
												[
													0.296,
													-10.355
												],
												[
													0,
													0
												],
												[
													-20.654,
													0.681
												],
												[
													-2.033,
													-11.419
												],
												[
													43.082,
													-0.658
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													24.542,
													-6.973
												],
												[
													9.839,
													7.328
												],
												[
													-0.082,
													2.88
												],
												[
													0,
													0
												],
												[
													18.083,
													0.504
												],
												[
													-1.331,
													22.64
												],
												[
													-49.811,
													0.798
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-15.971,
													-71.475
												],
												[
													29.979,
													-72.516
												],
												[
													39.914,
													-30.241
												],
												[
													39.696,
													-25.583
												],
												[
													70.681,
													-21.64
												],
												[
													91.541,
													-5.717
												],
												[
													32.86,
													43.231
												],
												[
													-91.541,
													10.362
												],
												[
													-56.971,
													-74.374
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								0.808000033509,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								109.101,
								86.99
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 3",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "chin",
		parent: 13,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 18.215,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					38.146,
					-21.961,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.143,
										y: 0
									},
									t: 11,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-46.567,
													6.362
												],
												[
													-34.212,
													12.706
												]
											],
											o: [
												[
													0,
													0
												],
												[
													46.815,
													-6.396
												],
												[
													29.196,
													-10.844
												]
											],
											v: [
												[
													65.167,
													59.64
												],
												[
													12.996,
													144.865
												],
												[
													137.11,
													115.777
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 14,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-46.425,
													7.2
												],
												[
													-71.983,
													8.771
												]
											],
											o: [
												[
													0,
													0
												],
												[
													45.231,
													-6.945
												],
												[
													29.425,
													-10.137
												]
											],
											v: [
												[
													60.455,
													59.943
												],
												[
													20.138,
													146.592
												],
												[
													126.118,
													115.752
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.4,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 16,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-46.325,
													7.79
												],
												[
													-72.025,
													3.753
												]
											],
											o: [
												[
													0,
													0
												],
												[
													44.114,
													-7.332
												],
												[
													29.586,
													-9.639
												]
											],
											v: [
												[
													57.134,
													60.156
												],
												[
													20.323,
													151.834
												],
												[
													124.013,
													114.926
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.912,
										y: 1
									},
									o: {
										x: 0.747,
										y: 0
									},
									t: 26,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-46.056,
													9.37
												],
												[
													-48.849,
													13.515
												]
											],
											o: [
												[
													0,
													0
												],
												[
													41.125,
													-8.367
												],
												[
													30.017,
													-8.305
												]
											],
											v: [
												[
													48.244,
													60.727
												],
												[
													20.82,
													165.869
												],
												[
													122.743,
													117.365
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 33,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-40.218,
													14.865
												],
												[
													-50.575,
													10.107
												]
											],
											o: [
												[
													0,
													0
												],
												[
													34.687,
													-12.821
												],
												[
													30.541,
													-6.103
												]
											],
											v: [
												[
													62.737,
													64.319
												],
												[
													33.389,
													159.678
												],
												[
													117.982,
													118.735
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 35,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-43.491,
													11.208
												],
												[
													-36.763,
													7.545
												]
											],
											o: [
												[
													0,
													0
												],
												[
													41.809,
													-10.835
												],
												[
													30.631,
													-5.601
												]
											],
											v: [
												[
													61.585,
													60.651
												],
												[
													26.303,
													153.816
												],
												[
													119.017,
													118.512
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 36,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-45.008,
													10.587
												],
												[
													-33.241,
													6.084
												]
											],
											o: [
												[
													0,
													0
												],
												[
													42.211,
													-9.964
												],
												[
													30.704,
													-5.2
												]
											],
											v: [
												[
													60.851,
													58.314
												],
												[
													22.487,
													153.887
												],
												[
													109.253,
													120.029
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 37,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-45.872,
													10.234
												],
												[
													-37.533,
													6.07
												]
											],
											o: [
												[
													0,
													0
												],
												[
													42.441,
													-9.468
												],
												[
													30.746,
													-4.972
												]
											],
											v: [
												[
													60.434,
													56.983
												],
												[
													12.996,
													144.865
												],
												[
													103.69,
													120.893
												]
											],
											c: true
										}
									]
								},
								{
									t: 38,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-45.872,
													10.234
												],
												[
													-37.882,
													7.258
												]
											],
											o: [
												[
													0,
													0
												],
												[
													42.441,
													-9.468
												],
												[
													30.589,
													-5.861
												]
											],
											v: [
												[
													60.434,
													56.983
												],
												[
													12.996,
													144.865
												],
												[
													117.925,
													118.131
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								0.807843017578,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 11,
		op: 46,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "collar back",
		parent: 12,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0.838,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					54.47,
					72.243,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					48.601,
					75.24,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										3.461,
										-17.931
									],
									[
										0,
										0
									]
								],
								o: [
									[
										-2.427,
										12.574
									],
									[
										0,
										0
									]
								],
								v: [
									[
										17.914,
										40.41
									],
									[
										11.715,
										67.263
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.579999976065,
								0.211999990426,
								0.556999954523,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 16.987,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								49.128,
								71.111
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 15,
		op: 37,
		st: 15,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "body fur 1",
		parent: 22,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.495
							],
							y: [
								0
							]
						},
						t: 0,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 15,
						s: [
							-10
						]
					},
					{
						t: 34,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.495,
							y: 0
						},
						t: 0,
						s: [
							111.852,
							68.257,
							0
						],
						to: [
							-1.64,
							9.12,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 15,
						s: [
							113.102,
							89.84,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-2.61,
							12.22,
							0
						]
					},
					{
						t: 34,
						s: [
							111.852,
							68.257,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					17.964,
					11.324,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										9.515,
										1.079
									],
									[
										3.634,
										-5.141
									],
									[
										1.341,
										0.566
									],
									[
										-3.28,
										5.944
									]
								],
								o: [
									[
										6.224,
										2.527
									],
									[
										-2.527,
										3.573
									],
									[
										1.976,
										3.556
									],
									[
										3.161,
										-5.726
									]
								],
								v: [
									[
										-8.282,
										-12.174
									],
									[
										2.145,
										5.953
									],
									[
										-7.967,
										5.926
									],
									[
										5.122,
										6.23
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.579999976065,
								0.211999990426,
								0.556999954523,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								28.326,
								12.424
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-0.966,
										8.746
									],
									[
										-6.255,
										-0.682
									],
									[
										1.619,
										3.01
									],
									[
										2.243,
										0.106
									]
								],
								o: [
									[
										-3.388,
										3.448
									],
									[
										6.348,
										0.691
									],
									[
										-0.482,
										5.257
									],
									[
										-2.275,
										-0.106
									]
								],
								v: [
									[
										-4.211,
										-7.376
									],
									[
										-0.367,
										6.685
									],
									[
										5.98,
										-3.354
									],
									[
										0.423,
										3.77
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.579999976065,
								0.211999990426,
								0.556999954523,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								7.849,
								15.67
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 17,
		ty: 4,
		nm: "body fur 2",
		parent: 22,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.519
							],
							y: [
								0
							]
						},
						t: 0,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 15,
						s: [
							-8
						]
					},
					{
						t: 34,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.519,
							y: 0
						},
						t: 0,
						s: [
							139.437,
							205.161,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							-3.6,
							-1.4,
							0
						]
					},
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.333,
							y: 0
						},
						t: 15,
						s: [
							145.687,
							209.378,
							0
						],
						to: [
							-4.025,
							-1.204,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 34,
						s: [
							139.437,
							205.161,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					15.539,
					14.064,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-0.138,
										7.308
									],
									[
										-7.884,
										0.021
									]
								],
								o: [
									[
										0,
										0
									],
									[
										-3.204,
										3.99
									]
								],
								v: [
									[
										-5.44,
										-4.161
									],
									[
										5.578,
										0.171
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.579999976065,
								0.211999990426,
								0.556999954523,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								22.587,
								25.396
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										-3.456,
										2.938
									],
									[
										-3.711,
										-5.59
									],
									[
										-2.935,
										5.695
									],
									[
										2.796,
										4.975
									]
								],
								o: [
									[
										-6.409,
										1.452
									],
									[
										3.782,
										5.695
									],
									[
										-2.253,
										1.904
									],
									[
										-2.522,
										-4.489
									]
								],
								v: [
									[
										3.384,
										-11.22
									],
									[
										-6.155,
										5.525
									],
									[
										9.866,
										1.883
									],
									[
										-3.749,
										3.668
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.579999976065,
								0.211999990426,
								0.556999954523,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								10.116,
								11.47
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 18,
		ty: 3,
		nm: "front l leg control",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 0,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-238.31,
					161.198,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.624,
								0.624,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 10,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.727,
								0.727,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.543,
								0.543,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 29,
						s: [
							100,
							115,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 41,
						s: [
							100,
							98,
							100
						]
					},
					{
						t: 48,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 19,
		ty: 4,
		nm: "front l leg 2",
		parent: 18,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-2.512,
					0.092,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					19.007,
					181.114,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.596,
								0.596,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 0,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 15,
						s: [
							100,
							91,
							100
						]
					},
					{
						i: {
							x: [
								0.843,
								0.843,
								0.843
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 41,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.379,
								0.379,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.276,
								0.276,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 68,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.695,
								0.695,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 74,
						s: [
							100,
							105,
							100
						]
					},
					{
						t: 89,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										5.053,
										3.423
									],
									[
										5.807,
										-5.302
									]
								],
								o: [
									[
										1.112,
										4.599
									],
									[
										8.381,
										-0.823
									]
								],
								v: [
									[
										0.055,
										-7.13
									],
									[
										-5.108,
										7.13
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.579999976065,
								0.211999990426,
								0.556999954523,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								59.006,
								174.347
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										4.985,
										3.592
									],
									[
										4.153,
										-2.979
									]
								],
								o: [
									[
										0.957,
										3.531
									],
									[
										5.801,
										0
									]
								],
								v: [
									[
										-0.436,
										-5.931
									],
									[
										-4.549,
										5.931
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.579999976065,
								0.211999990426,
								0.556999954523,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								50.175,
								175.545
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.845,
										y: 0.924
									},
									o: {
										x: 0.473,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													-1.712,
													20.385
												],
												[
													17.98,
													-6.622
												]
											],
											o: [
												[
													-4.724,
													18.207
												],
												[
													17.032,
													-1.092
												]
											],
											v: [
												[
													26.084,
													-18.208
												],
												[
													-26.084,
													18.208
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.546,
										y: 1
									},
									o: {
										x: 0.462,
										y: 0.214
									},
									t: 13,
									s: [
										{
											i: [
												[
													-4.5,
													17.064
												],
												[
													16.703,
													-9.388
												]
											],
											o: [
												[
													-10.375,
													14.887
												],
												[
													16.644,
													-3.777
												]
											],
											v: [
												[
													35.744,
													-18.125
												],
												[
													-18.119,
													22.004
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 25,
									s: [
										{
											i: [
												[
													-11.965,
													21.408
												],
												[
													17.98,
													-6.622
												]
											],
											o: [
												[
													-14.34,
													15.62
												],
												[
													17.032,
													-1.092
												]
											],
											v: [
												[
													36.334,
													-12.774
												],
												[
													-21.709,
													18.798
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.601,
										y: 0
									},
									t: 29,
									s: [
										{
											i: [
												[
													-11.547,
													21.319
												],
												[
													17.98,
													-6.622
												]
											],
											o: [
												[
													-14.922,
													16.111
												],
												[
													17.032,
													-1.092
												]
											],
											v: [
												[
													33.415,
													-14.592
												],
												[
													-22.261,
													18.724
												]
											],
											c: true
										}
									]
								},
								{
									t: 43,
									s: [
										{
											i: [
												[
													-1.712,
													20.385
												],
												[
													17.98,
													-6.622
												]
											],
											o: [
												[
													-4.724,
													18.207
												],
												[
													17.032,
													-1.092
												]
											],
											v: [
												[
													26.084,
													-18.208
												],
												[
													-26.084,
													18.208
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.579999976065,
								0.211999990426,
								0.556999954523,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								93.836,
								103.926
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 3",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 3,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.791,
										y: 1
									},
									o: {
										x: 0.6,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0.376,
													4.733
												],
												[
													-5.796,
													0.584
												]
											],
											o: [
												[
													1.825,
													1.461
												],
												[
													-4.254,
													4.02
												]
											],
											v: [
												[
													-1.387,
													-3.667
												],
												[
													10.887,
													-0.569
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 13,
									s: [
										{
											i: [
												[
													0.376,
													4.733
												],
												[
													-5.796,
													0.584
												]
											],
											o: [
												[
													1.825,
													1.461
												],
												[
													-4.254,
													4.02
												]
											],
											v: [
												[
													5.739,
													-0.129
												],
												[
													18.012,
													2.969
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.567,
										y: 0
									},
									t: 29,
									s: [
										{
											i: [
												[
													0.376,
													4.733
												],
												[
													-5.796,
													0.584
												]
											],
											o: [
												[
													1.825,
													1.461
												],
												[
													-4.254,
													4.02
												]
											],
											v: [
												[
													1.614,
													-3.667
												],
												[
													13.887,
													-0.569
												]
											],
											c: true
										}
									]
								},
								{
									t: 43,
									s: [
										{
											i: [
												[
													0.376,
													4.733
												],
												[
													-5.796,
													0.584
												]
											],
											o: [
												[
													1.825,
													1.461
												],
												[
													-4.254,
													4.02
												]
											],
											v: [
												[
													-1.387,
													-3.667
												],
												[
													10.887,
													-0.569
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.579999976065,
								0.211999990426,
								0.556999954523,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								37.836,
								127.154
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 4",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 4,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 0.937
									},
									o: {
										x: 0.482,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													23.893,
													-45.293
												],
												[
													9.25,
													-0.138
												],
												[
													0,
													0
												],
												[
													-2.568,
													7.177
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-11.373,
													112.015
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-9.25,
													0.138
												],
												[
													-11.97,
													0
												],
												[
													3.781,
													-10.57
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													80.398,
													-90.614
												],
												[
													-28.836,
													35.654
												],
												[
													-48.024,
													67.962
												],
												[
													-16.801,
													90.614
												],
												[
													-52.318,
													90.614
												],
												[
													-68.428,
													90.614
												],
												[
													-77.805,
													76.242
												],
												[
													-59.144,
													25.525
												],
												[
													-32.123,
													-46.786
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.489,
										y: 1
									},
									o: {
										x: 0.481,
										y: 0.186
									},
									t: 13,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													23.893,
													-45.293
												],
												[
													9.25,
													-0.138
												],
												[
													0,
													0
												],
												[
													-2.568,
													7.177
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-19.716,
													101.071
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-9.25,
													0.138
												],
												[
													-11.97,
													0
												],
												[
													4.202,
													-11.747
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													93.148,
													-90.606
												],
												[
													-18.961,
													40.29
												],
												[
													-48.024,
													67.962
												],
												[
													-16.801,
													90.614
												],
												[
													-52.318,
													90.614
												],
												[
													-68.428,
													90.614
												],
												[
													-77.805,
													76.242
												],
												[
													-46.084,
													23.959
												],
												[
													-18.123,
													-48.665
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.489,
										y: 1
									},
									o: {
										x: 0.602,
										y: 0
									},
									t: 25,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													28.733,
													-41.043
												],
												[
													9.25,
													-0.138
												],
												[
													4.747,
													2.55
												],
												[
													-2.568,
													7.177
												],
												[
													-9.973,
													22.627
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-11.373,
													112.015
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-9.25,
													0.138
												],
												[
													-4.982,
													-2.676
												],
												[
													4.202,
													-11.747
												],
												[
													14.028,
													-31.826
												],
												[
													0,
													0
												]
											],
											v: [
												[
													95.273,
													-90.614
												],
												[
													-24.086,
													35.418
												],
												[
													-42.84,
													63.01
												],
												[
													-16.801,
													90.614
												],
												[
													-48.787,
													90.745
												],
												[
													-67.086,
													86.663
												],
												[
													-73.355,
													71.662
												],
												[
													-49.096,
													15.489
												],
												[
													-17.069,
													-50.78
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.602,
										y: 0
									},
									t: 29,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													27.233,
													-40.486
												],
												[
													9.25,
													-0.138
												],
												[
													4.747,
													2.55
												],
												[
													-2.568,
													7.177
												],
												[
													-10.528,
													22.374
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-20.091,
													112.318
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-9.25,
													0.138
												],
												[
													-4.982,
													-2.676
												],
												[
													4.202,
													-11.747
												],
												[
													15.386,
													-32.698
												],
												[
													0,
													0
												]
											],
											v: [
												[
													93.773,
													-90.605
												],
												[
													-24.836,
													35.71
												],
												[
													-42.715,
													62.892
												],
												[
													-16.801,
													90.614
												],
												[
													-48.787,
													90.745
												],
												[
													-67.086,
													86.663
												],
												[
													-75.105,
													71.189
												],
												[
													-51.454,
													18.979
												],
												[
													-19.569,
													-50.962
												]
											],
											c: true
										}
									]
								},
								{
									t: 43,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													23.893,
													-45.293
												],
												[
													9.25,
													-0.138
												],
												[
													0,
													0
												],
												[
													-2.568,
													7.177
												],
												[
													-8.531,
													22.916
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-11.373,
													112.015
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-9.25,
													0.138
												],
												[
													-11.97,
													0
												],
												[
													4.202,
													-11.747
												],
												[
													12.186,
													-32.734
												],
												[
													0,
													0
												]
											],
											v: [
												[
													80.398,
													-90.614
												],
												[
													-28.836,
													35.654
												],
												[
													-48.024,
													67.962
												],
												[
													-16.801,
													90.614
												],
												[
													-52.318,
													90.614
												],
												[
													-68.428,
													90.614
												],
												[
													-77.805,
													76.242
												],
												[
													-56.584,
													18.644
												],
												[
													-32.123,
													-46.786
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								0.808000033509,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								80.648,
								90.864
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 5",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 5,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 20,
		ty: 4,
		nm: "body 4",
		parent: 22,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					146.067,
					130.607,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					146.067,
					130.607,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 11,
									s: [
										{
											i: [
												[
													30.011,
													13.135
												],
												[
													-39.346,
													-0.32
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-50.985,
													-22.315
												],
												[
													39.346,
													0.32
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													48.912,
													20.753
												],
												[
													37.608,
													109.85
												],
												[
													125.667,
													109.85
												],
												[
													115.099,
													37.465
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 16,
									s: [
										{
											i: [
												[
													30.624,
													12.667
												],
												[
													-39.346,
													-0.32
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-51.429,
													-21.272
												],
												[
													39.346,
													0.32
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													48.662,
													19.753
												],
												[
													32.358,
													102.85
												],
												[
													120.417,
													102.85
												],
												[
													123.099,
													33.715
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 22,
									s: [
										{
											i: [
												[
													43.68,
													-2.833
												],
												[
													-39.346,
													-0.32
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-55.538,
													3.603
												],
												[
													39.346,
													0.32
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													44.412,
													13.213
												],
												[
													41.108,
													94.6
												],
												[
													129.167,
													94.6
												],
												[
													116.099,
													-12.785
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 26,
									s: [
										{
											i: [
												[
													39.284,
													-4.46
												],
												[
													-39.346,
													-0.32
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-55.434,
													4.733
												],
												[
													39.346,
													0.32
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													43.818,
													12.243
												],
												[
													39.608,
													107.6
												],
												[
													124.417,
													88.31
												],
												[
													107.849,
													-15.316
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 30,
									s: [
										{
											i: [
												[
													23.742,
													-2.842
												],
												[
													-39.346,
													-0.32
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-55.26,
													6.616
												],
												[
													39.346,
													0.32
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													44.412,
													9.425
												],
												[
													16.608,
													89.85
												],
												[
													104.667,
													89.85
												],
												[
													89.099,
													-2.035
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 33,
									s: [
										{
											i: [
												[
													15.019,
													1.149
												],
												[
													-39.346,
													-0.32
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-55.493,
													-4.244
												],
												[
													39.346,
													0.32
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													45.662,
													9.253
												],
												[
													31.108,
													100.1
												],
												[
													119.167,
													100.1
												],
												[
													78.849,
													14.215
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 35,
									s: [
										{
											i: [
												[
													23.338,
													7.059
												],
												[
													-39.346,
													-0.32
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-55.588,
													-2.369
												],
												[
													39.346,
													0.32
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													43.995,
													12.586
												],
												[
													21.858,
													104.1
												],
												[
													109.917,
													104.1
												],
												[
													85.349,
													14.215
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 37,
									s: [
										{
											i: [
												[
													24.854,
													0.64
												],
												[
													-39.346,
													-0.32
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-55.636,
													-1.432
												],
												[
													39.346,
													0.32
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													43.162,
													15.503
												],
												[
													38.608,
													103.6
												],
												[
													126.667,
													103.6
												],
												[
													90.599,
													16.465
												]
											],
											c: true
										}
									]
								},
								{
									t: 43,
									s: [
										{
											i: [
												[
													35.437,
													8.385
												],
												[
													-39.346,
													-0.32
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-54.159,
													-12.816
												],
												[
													39.346,
													0.32
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													46.412,
													18.253
												],
												[
													38.858,
													103.1
												],
												[
													126.917,
													103.1
												],
												[
													110.349,
													29.215
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								0.808000033509,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								137.667,
								125.35
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 11,
		op: 43,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 21,
		ty: 4,
		nm: "body 2",
		parent: 22,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					146.067,
					130.607,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					146.067,
					130.607,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													44.773,
													-0.385
												],
												[
													-60.969,
													0.038
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-44.773,
													0.385
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													47.412,
													16.753
												],
												[
													49.358,
													125.1
												],
												[
													137.417,
													125.1
												],
												[
													109.599,
													16.465
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.352,
										y: 1
									},
									o: {
										x: 0.526,
										y: 0
									},
									t: 11,
									s: [
										{
											i: [
												[
													30.011,
													13.135
												],
												[
													-39.346,
													-0.32
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-50.985,
													-22.315
												],
												[
													39.346,
													0.32
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													47.412,
													19.003
												],
												[
													49.358,
													125.1
												],
												[
													137.417,
													125.1
												],
												[
													115.099,
													37.465
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.588,
										y: 1
									},
									o: {
										x: 0.521,
										y: 0
									},
									t: 28,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													-26.923,
													-0.789
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-66.523,
													-0.115
												],
												[
													40.241,
													1.179
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													44.912,
													13.003
												],
												[
													45.608,
													124.959
												],
												[
													132.917,
													89.888
												],
												[
													115.599,
													6.465
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 42,
									s: [
										{
											i: [
												[
													27.242,
													14.885
												],
												[
													-29.798,
													0.21
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-20.661,
													-11.29
												],
												[
													29.798,
													-0.21
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													41.912,
													15.753
												],
												[
													49.358,
													125.1
												],
												[
													137.417,
													125.1
												],
												[
													108.099,
													27.965
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 47,
									s: [
										{
											i: [
												[
													25.769,
													-0.587
												],
												[
													-60.969,
													0.038
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-60.773,
													1.385
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													47.412,
													16.753
												],
												[
													49.358,
													125.1
												],
												[
													137.417,
													125.1
												],
												[
													109.599,
													16.465
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 68,
									s: [
										{
											i: [
												[
													25.769,
													-0.587
												],
												[
													-60.969,
													0.038
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-60.773,
													1.385
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													47.412,
													16.753
												],
												[
													49.358,
													125.1
												],
												[
													137.417,
													125.1
												],
												[
													109.599,
													16.465
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.575,
										y: 0
									},
									t: 74,
									s: [
										{
											i: [
												[
													26.803,
													4.74
												],
												[
													-60.969,
													0.038
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-59.86,
													-10.585
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													42.138,
													14.124
												],
												[
													49.358,
													125.1
												],
												[
													137.417,
													125.1
												],
												[
													108.397,
													21.895
												]
											],
											c: true
										}
									]
								},
								{
									t: 85,
									s: [
										{
											i: [
												[
													25.769,
													-0.587
												],
												[
													-60.969,
													0.038
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											o: [
												[
													-60.773,
													1.385
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													47.412,
													16.753
												],
												[
													49.358,
													125.1
												],
												[
													137.417,
													125.1
												],
												[
													109.599,
													16.465
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								0.808000033509,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								137.667,
								125.35
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 22,
		ty: 4,
		nm: "body",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0.167
							]
						},
						t: 68,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.387
							],
							y: [
								0
							]
						},
						t: 76,
						s: [
							1.5
						]
					},
					{
						t: 90,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.578,
							y: 1
						},
						o: {
							x: 0.591,
							y: 0
						},
						t: 0,
						s: [
							-47.02,
							158.338,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.578,
							y: 0.578
						},
						o: {
							x: 0.431,
							y: 0.431
						},
						t: 15,
						s: [
							-29.52,
							158.338,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.492,
							y: 0.525
						},
						o: {
							x: 0.431,
							y: 0
						},
						t: 17,
						s: [
							-29.52,
							158.338,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.524,
							y: 1
						},
						o: {
							x: 0.587,
							y: 0.287
						},
						t: 29,
						s: [
							-35.447,
							158.338,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 41,
						s: [
							-46.989,
							158.369,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					187.567,
					250.857,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.486,
								0.486,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.5,
								0.5,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 10,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.727,
								0.727,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.543,
								0.543,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 27,
						s: [
							100,
							105,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 41,
						s: [
							100,
							97,
							100
						]
					},
					{
						i: {
							x: [
								0.833,
								0.833,
								0.833
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 49,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0.167,
								0
							]
						},
						t: 68,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.677,
								0.677,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 73,
						s: [
							100,
							102,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.167,
								0.167,
								0.167
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 88,
						s: [
							100,
							99.5,
							100
						]
					},
					{
						t: 95,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.615,
										y: 1
									},
									o: {
										x: 0.581,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													44.8,
													-4.306
												],
												[
													25.387,
													-23.574
												],
												[
													-34.162,
													-32.458
												],
												[
													-11.442,
													-10.923
												],
												[
													-35.543,
													0
												]
											],
											o: [
												[
													-28.954,
													-105.758
												],
												[
													-25.028,
													2.405
												],
												[
													-53.964,
													41.847
												],
												[
													16.251,
													15.442
												],
												[
													25.709,
													24.544
												],
												[
													0,
													0
												]
											],
											v: [
												[
													47.412,
													16.753
												],
												[
													-50.267,
													-111.475
												],
												[
													-83.453,
													-101.526
												],
												[
													-91.661,
													47.284
												],
												[
													-50.099,
													86.864
												],
												[
													49.358,
													125.1
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 15,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													43.686,
													-10.821
												],
												[
													7.746,
													-8.801
												],
												[
													-36.59,
													-29.694
												],
												[
													-12.536,
													-9.647
												],
												[
													-35.543,
													0
												]
											],
											o: [
												[
													-35.901,
													-101.644
												],
												[
													-12.307,
													3.049
												],
												[
													-42.354,
													49.145
												],
												[
													17.407,
													14.126
												],
												[
													28.169,
													21.677
												],
												[
													0,
													0
												]
											],
											v: [
												[
													52.408,
													21.988
												],
												[
													-68.452,
													-88.194
												],
												[
													-97.873,
													-72.275
												],
												[
													-88.805,
													58.046
												],
												[
													-43.958,
													96.99
												],
												[
													49.358,
													125.1
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 33,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													46.911,
													-5.616
												],
												[
													20.881,
													-19.801
												],
												[
													-32.742,
													-33.852
												],
												[
													-11.683,
													-10.639
												],
												[
													-35.543,
													0
												]
											],
											o: [
												[
													-27.565,
													-105.782
												],
												[
													-21.517,
													4.353
												],
												[
													-50.999,
													43.711
												],
												[
													15.576,
													16.104
												],
												[
													27.057,
													24.638
												],
												[
													0,
													0
												]
											],
											v: [
												[
													48.688,
													18.09
												],
												[
													-54.912,
													-105.529
												],
												[
													-87.136,
													-94.055
												],
												[
													-86.178,
													41.574
												],
												[
													-38.308,
													88.159
												],
												[
													49.358,
													125.1
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.705,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 38,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													49.446,
													-7.616
												],
												[
													24.792,
													-23.076
												],
												[
													-33.54,
													-33.094
												],
												[
													-11.551,
													-10.804
												],
												[
													-35.543,
													0
												]
											],
											o: [
												[
													-25.082,
													-107.015
												],
												[
													-24.431,
													3.763
												],
												[
													-53.573,
													42.093
												],
												[
													15.956,
													15.744
												],
												[
													25.554,
													23.902
												],
												[
													0,
													0
												]
											],
											v: [
												[
													47.58,
													16.929
												],
												[
													-50.88,
													-110.69
												],
												[
													-83.939,
													-100.54
												],
												[
													-89.892,
													44.653
												],
												[
													-45.363,
													87.653
												],
												[
													49.358,
													125.1
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 44,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													44.8,
													-4.306
												],
												[
													25.387,
													-23.574
												],
												[
													-34.162,
													-32.458
												],
												[
													-11.442,
													-10.923
												],
												[
													-35.543,
													0
												]
											],
											o: [
												[
													-28.954,
													-105.758
												],
												[
													-25.028,
													2.405
												],
												[
													-53.964,
													41.847
												],
												[
													16.251,
													15.442
												],
												[
													25.709,
													24.544
												],
												[
													0,
													0
												]
											],
											v: [
												[
													47.412,
													16.753
												],
												[
													-50.267,
													-111.475
												],
												[
													-83.453,
													-101.526
												],
												[
													-91.661,
													47.284
												],
												[
													-50.099,
													86.864
												],
												[
													49.358,
													125.1
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.464,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0
									},
									t: 68,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													44.8,
													-4.306
												],
												[
													25.387,
													-23.574
												],
												[
													-34.162,
													-32.458
												],
												[
													-11.442,
													-10.923
												],
												[
													-35.543,
													0
												]
											],
											o: [
												[
													-28.954,
													-105.758
												],
												[
													-25.028,
													2.405
												],
												[
													-53.964,
													41.847
												],
												[
													16.251,
													15.442
												],
												[
													25.709,
													24.544
												],
												[
													0,
													0
												]
											],
											v: [
												[
													47.412,
													16.753
												],
												[
													-50.267,
													-111.475
												],
												[
													-83.453,
													-101.526
												],
												[
													-91.661,
													47.284
												],
												[
													-50.099,
													86.864
												],
												[
													49.358,
													125.1
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.618,
										y: 1
									},
									o: {
										x: 0.53,
										y: 0
									},
									t: 74,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													44.8,
													-4.306
												],
												[
													25.387,
													-23.574
												],
												[
													-34.162,
													-32.458
												],
												[
													-11.442,
													-10.923
												],
												[
													-35.543,
													0
												]
											],
											o: [
												[
													-27.799,
													-108.53
												],
												[
													-25.028,
													2.405
												],
												[
													-53.964,
													41.847
												],
												[
													16.251,
													15.442
												],
												[
													25.709,
													24.544
												],
												[
													0,
													0
												]
											],
											v: [
												[
													45.412,
													17.936
												],
												[
													-50.052,
													-112.53
												],
												[
													-83.238,
													-102.581
												],
												[
													-91.661,
													47.284
												],
												[
													-50.099,
													86.864
												],
												[
													49.358,
													125.1
												]
											],
											c: true
										}
									]
								},
								{
									t: 91,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													44.8,
													-4.306
												],
												[
													25.387,
													-23.574
												],
												[
													-34.162,
													-32.458
												],
												[
													-11.442,
													-10.923
												],
												[
													-35.543,
													0
												]
											],
											o: [
												[
													-28.954,
													-105.758
												],
												[
													-25.028,
													2.405
												],
												[
													-53.964,
													41.847
												],
												[
													16.251,
													15.442
												],
												[
													25.709,
													24.544
												],
												[
													0,
													0
												]
											],
											v: [
												[
													47.412,
													16.753
												],
												[
													-50.267,
													-111.475
												],
												[
													-83.453,
													-101.526
												],
												[
													-91.661,
													47.284
												],
												[
													-50.099,
													86.864
												],
												[
													49.358,
													125.1
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								0.808000033509,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								137.667,
								125.35
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 2",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 23,
		ty: 4,
		nm: "tail mask",
		parent: 27,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 9.5,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-20.131,
					8.516,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					96.706,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.56,
										y: 1
									},
									o: {
										x: 0.15,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													-43.335,
													32.035
												],
												[
													-23.993,
													-59.333
												]
											],
											o: [
												[
													-23.56,
													41.456
												],
												[
													-35.667,
													3.234
												]
											],
											v: [
												[
													-138.403,
													-205.086
												],
												[
													-133.917,
													-65.158
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.904,
										y: 1
									},
									o: {
										x: 0.623,
										y: 0
									},
									t: 7,
									s: [
										{
											i: [
												[
													-4.853,
													68.274
												],
												[
													-17.933,
													-55.559
												]
											],
											o: [
												[
													15.623,
													34.349
												],
												[
													-32.736,
													5.646
												]
											],
											v: [
												[
													-186.393,
													-200.229
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.483,
										y: 0
									},
									t: 12,
									s: [
										{
											i: [
												[
													-52.202,
													35.718
												],
												[
													-27.945,
													-50.141
												]
											],
											o: [
												[
													-16.702,
													47.855
												],
												[
													-38.945,
													11.838
												]
											],
											v: [
												[
													-141.048,
													-210.547
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.738,
										y: 1
									},
									o: {
										x: 0.583,
										y: 0
									},
									t: 16,
									s: [
										{
											i: [
												[
													5.643,
													63.042
												],
												[
													-21.006,
													-53.661
												]
											],
											o: [
												[
													18.788,
													27.03
												],
												[
													-34.945,
													-19.926
												]
											],
											v: [
												[
													-195.467,
													-205.221
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.759,
										y: 1
									},
									o: {
										x: 0.473,
										y: 0
									},
									t: 20,
									s: [
										{
											i: [
												[
													-48.946,
													46.657
												],
												[
													-26.944,
													-52.673
												]
											],
											o: [
												[
													-16.946,
													49.657
												],
												[
													-34.945,
													-19.926
												]
											],
											v: [
												[
													-144.804,
													-210.907
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.494,
										y: 0
									},
									t: 24,
									s: [
										{
											i: [
												[
													13.75,
													70.108
												],
												[
													-20.049,
													-55.203
												]
											],
											o: [
												[
													29.594,
													31.076
												],
												[
													-36.292,
													-10.241
												]
											],
											v: [
												[
													-203.711,
													-204.617
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 26,
									s: [
										{
											i: [
												[
													-10.998,
													54.777
												],
												[
													-21.401,
													-53.013
												]
											],
											o: [
												[
													6.71,
													36.803
												],
												[
													-34.685,
													-10.922
												]
											],
											v: [
												[
													-169.404,
													-200.958
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.78,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 27,
									s: [
										{
											i: [
												[
													-37.966,
													38.071
												],
												[
													-22.875,
													-50.626
												]
											],
											o: [
												[
													-13.29,
													43.584
												],
												[
													-39.061,
													-6.407
												]
											],
											v: [
												[
													-144.533,
													-201.01
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.436,
										y: 0
									},
									t: 28,
									s: [
										{
											i: [
												[
													-57.081,
													26.229
												],
												[
													-23.92,
													-48.934
												]
											],
											o: [
												[
													-35.901,
													47.468
												],
												[
													-41.351,
													-11.089
												]
											],
											v: [
												[
													-122.23,
													-202.964
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.848,
										y: 1
									},
									o: {
										x: 0.494,
										y: 0
									},
									t: 32,
									s: [
										{
											i: [
												[
													11.968,
													55.576
												],
												[
													-15.639,
													-47.886
												]
											],
											o: [
												[
													21.045,
													28.051
												],
												[
													-35.836,
													-1.496
												]
											],
											v: [
												[
													-200.75,
													-200.859
												],
												[
													-132.904,
													-61.423
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.462,
										y: 0
									},
									t: 36,
									s: [
										{
											i: [
												[
													-53.509,
													27.896
												],
												[
													-27.398,
													-58.958
												]
											],
											o: [
												[
													-29.156,
													41.239
												],
												[
													-41.261,
													-3.008
												]
											],
											v: [
												[
													-127.823,
													-204.729
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.655,
										y: 0
									},
									t: 41,
									s: [
										{
											i: [
												[
													29.017,
													61.876
												],
												[
													-23.603,
													-56.073
												]
											],
											o: [
												[
													35.527,
													35.025
												],
												[
													-42.644,
													-26.153
												]
											],
											v: [
												[
													-204.947,
													-200.224
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 1,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 44,
									s: [
										{
											i: [
												[
													5.623,
													62.211
												],
												[
													-29.256,
													-60.364
												]
											],
											o: [
												[
													24.269,
													36.925
												],
												[
													-42.644,
													-26.153
												]
											],
											v: [
												[
													-177.457,
													-201.759
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.773,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 45,
									s: [
										{
											i: [
												[
													-17.185,
													62.538
												],
												[
													-34.767,
													-64.547
												]
											],
											o: [
												[
													13.293,
													38.777
												],
												[
													-42.644,
													-26.153
												]
											],
											v: [
												[
													-160.733,
													-203.154
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.56,
										y: 0
									},
									t: 47,
									s: [
										{
											i: [
												[
													-43.85,
													53.497
												],
												[
													-34.956,
													-48.959
												]
											],
											o: [
												[
													1.053,
													36.527
												],
												[
													-42.644,
													-26.153
												]
											],
											v: [
												[
													-138.242,
													-203.066
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 49,
									s: [
										{
											i: [
												[
													-43.696,
													52.856
												],
												[
													-30.75,
													-47.297
												]
											],
											o: [
												[
													-15.21,
													35.667
												],
												[
													-42.644,
													-26.153
												]
											],
											v: [
												[
													-134.285,
													-198.667
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.376,
										y: 1
									},
									o: {
										x: 0.142,
										y: 0
									},
									t: 52,
									s: [
										{
											i: [
												[
													-42.872,
													49.42
												],
												[
													-24.546,
													-52.153
												]
											],
											o: [
												[
													-20.883,
													42.916
												],
												[
													-42.644,
													-26.153
												]
											],
											v: [
												[
													-148.814,
													-208.939
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.79,
										y: 1
									},
									o: {
										x: 0.656,
										y: 0
									},
									t: 56,
									s: [
										{
											i: [
												[
													-9.123,
													71.888
												],
												[
													-20.687,
													-54.845
												]
											],
											o: [
												[
													14.908,
													32.461
												],
												[
													-42.644,
													-26.153
												]
											],
											v: [
												[
													-181.913,
													-206.707
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.069,
										y: 0
									},
									t: 61,
									s: [
										{
											i: [
												[
													-19.148,
													60.365
												],
												[
													-31.596,
													-55.35
												]
											],
											o: [
												[
													7.731,
													33.398
												],
												[
													-42.644,
													-26.153
												]
											],
											v: [
												[
													-158.22,
													-204.347
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.185,
										y: 0
									},
									t: 64,
									s: [
										{
											i: [
												[
													-31.754,
													51.773
												],
												[
													-25.832,
													-55.233
												]
											],
											o: [
												[
													-9.556,
													48.065
												],
												[
													-42.644,
													-26.153
												]
											],
											v: [
												[
													-150.499,
													-207.554
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.252,
										y: 0
									},
									t: 69,
									s: [
										{
											i: [
												[
													-4.406,
													59.589
												],
												[
													-17.07,
													-53.887
												]
											],
											o: [
												[
													21.678,
													38.641
												],
												[
													-42.644,
													-26.153
												]
											],
											v: [
												[
													-180.811,
													-201.029
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 72,
									s: [
										{
											i: [
												[
													-0.544,
													58.872
												],
												[
													-29.345,
													-61.476
												]
											],
											o: [
												[
													20.784,
													32.902
												],
												[
													-42.644,
													-26.153
												]
											],
											v: [
												[
													-168.576,
													-188.552
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 74,
									s: [
										{
											i: [
												[
													-17.672,
													48.713
												],
												[
													-30.382,
													-64.025
												]
											],
											o: [
												[
													10.54,
													32.351
												],
												[
													-42.644,
													-26.153
												]
											],
											v: [
												[
													-156.756,
													-188.852
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.806,
										y: 1
									},
									o: {
										x: 0.143,
										y: 0
									},
									t: 77,
									s: [
										{
											i: [
												[
													-43.365,
													33.474
												],
												[
													-31.938,
													-67.849
												]
											],
											o: [
												[
													-10.47,
													29.022
												],
												[
													-42.644,
													-26.153
												]
											],
											v: [
												[
													-137.484,
													-188.452
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.462,
										y: 0
									},
									t: 83,
									s: [
										{
											i: [
												[
													-75.885,
													5.713
												],
												[
													-31.202,
													-63.941
												]
											],
											o: [
												[
													-39.644,
													24.546
												],
												[
													-42.644,
													-26.153
												]
											],
											v: [
												[
													-114.321,
													-189.892
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.429,
										y: 1
									},
									o: {
										x: 0.196,
										y: 0
									},
									t: 98,
									s: [
										{
											i: [
												[
													-65.316,
													39.308
												],
												[
													-31.853,
													-66.501
												]
											],
											o: [
												[
													-24.383,
													37.094
												],
												[
													-42.644,
													-26.153
												]
											],
											v: [
												[
													-135.923,
													-208.068
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								},
								{
									t: 105,
									s: [
										{
											i: [
												[
													-65.316,
													39.308
												],
												[
													-29.755,
													-61.902
												]
											],
											o: [
												[
													-21.478,
													35.278
												],
												[
													-42.644,
													-26.153
												]
											],
											v: [
												[
													-138.84,
													-205.778
												],
												[
													-128.806,
													-58.577
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								0.807843197093,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 24,
		ty: 4,
		nm: "tail piece 4",
		parent: 25,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.315
							],
							y: [
								0.15
							]
						},
						t: 0,
						s: [
							23
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								0.882
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 7,
						s: [
							4
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								-0.032
							]
						},
						t: 12,
						s: [
							7
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 16,
						s: [
							-4
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 20,
						s: [
							19
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 24,
						s: [
							1
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 28,
						s: [
							28
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 32,
						s: [
							2
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 36,
						s: [
							27
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 40,
						s: [
							-6
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 45,
						s: [
							-2
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 51,
						s: [
							18
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 58,
						s: [
							4
						]
					},
					{
						i: {
							x: [
								0.777
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.488
							],
							y: [
								0
							]
						},
						t: 65,
						s: [
							16
						]
					},
					{
						i: {
							x: [
								0.679
							],
							y: [
								1.278
							]
						},
						o: {
							x: [
								0.4
							],
							y: [
								0
							]
						},
						t: 70,
						s: [
							2
						]
					},
					{
						i: {
							x: [
								0.406
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.181
							],
							y: [
								0.174
							]
						},
						t: 73,
						s: [
							-12.757
						]
					},
					{
						i: {
							x: [
								0.731
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.55
							],
							y: [
								0
							]
						},
						t: 84,
						s: [
							36.026
						]
					},
					{
						i: {
							x: [
								0.744
							],
							y: [
								0.818
							]
						},
						o: {
							x: [
								0.421
							],
							y: [
								0
							]
						},
						t: 100,
						s: [
							20.026
						]
					},
					{
						t: 105,
						s: [
							23
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-168.25,
					-98.75,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-168.25,
					-98.75,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 1,
									s: [
										{
											i: [
												[
													-1.771,
													10.341
												],
												[
													-2.278,
													-23.527
												],
												[
													4.997,
													17.35
												]
											],
											o: [
												[
													-5.961,
													-1.297
												],
												[
													1.639,
													16.93
												],
												[
													-5.619,
													-19.508
												]
											],
											v: [
												[
													-162.789,
													-137.203
												],
												[
													-176.889,
													-105.18
												],
												[
													-159.943,
													-98.378
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 8,
									s: [
										{
											i: [
												[
													5.657,
													6.164
												],
												[
													-0.758,
													-12.93
												],
												[
													2.437,
													17.89
												]
											],
											o: [
												[
													-2.599,
													5.491
												],
												[
													0.996,
													16.98
												],
												[
													-2.82,
													-20.698
												]
											],
											v: [
												[
													-171.988,
													-138.294
												],
												[
													-176.889,
													-105.18
												],
												[
													-159.943,
													-98.378
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 13,
									s: [
										{
											i: [
												[
													-1.771,
													10.341
												],
												[
													-2.278,
													-23.527
												],
												[
													4.997,
													17.35
												]
											],
											o: [
												[
													-5.961,
													-1.297
												],
												[
													1.639,
													16.93
												],
												[
													-5.619,
													-19.508
												]
											],
											v: [
												[
													-162.789,
													-137.203
												],
												[
													-176.889,
													-105.18
												],
												[
													-159.943,
													-98.378
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 17,
									s: [
										{
											i: [
												[
													5.657,
													6.164
												],
												[
													-0.758,
													-12.93
												],
												[
													2.437,
													17.89
												]
											],
											o: [
												[
													-2.599,
													5.491
												],
												[
													0.996,
													16.98
												],
												[
													-2.82,
													-20.698
												]
											],
											v: [
												[
													-171.988,
													-138.294
												],
												[
													-176.889,
													-105.18
												],
												[
													-159.943,
													-98.378
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 21,
									s: [
										{
											i: [
												[
													-1.771,
													10.341
												],
												[
													-2.278,
													-23.527
												],
												[
													4.997,
													17.35
												]
											],
											o: [
												[
													-5.961,
													-1.297
												],
												[
													1.639,
													16.93
												],
												[
													-5.619,
													-19.508
												]
											],
											v: [
												[
													-162.789,
													-137.203
												],
												[
													-176.889,
													-105.18
												],
												[
													-159.943,
													-98.378
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 25,
									s: [
										{
											i: [
												[
													7.528,
													6.797
												],
												[
													-0.758,
													-12.93
												],
												[
													2.437,
													17.89
												]
											],
											o: [
												[
													-0.513,
													6.725
												],
												[
													0.996,
													16.98
												],
												[
													-2.82,
													-20.698
												]
											],
											v: [
												[
													-176.228,
													-138.02
												],
												[
													-176.889,
													-105.18
												],
												[
													-159.943,
													-98.378
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 29,
									s: [
										{
											i: [
												[
													-3.455,
													10.13
												],
												[
													-2.278,
													-23.527
												],
												[
													7.312,
													16.508
												]
											],
											o: [
												[
													-5.961,
													-1.297
												],
												[
													1.639,
													16.93
												],
												[
													-7.603,
													-17.164
												]
											],
											v: [
												[
													-162.789,
													-137.203
												],
												[
													-176.889,
													-105.18
												],
												[
													-159.943,
													-98.378
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 33,
									s: [
										{
											i: [
												[
													5.657,
													6.164
												],
												[
													-0.758,
													-12.93
												],
												[
													2.437,
													17.89
												]
											],
											o: [
												[
													-2.599,
													5.491
												],
												[
													0.996,
													16.98
												],
												[
													-2.82,
													-20.698
												]
											],
											v: [
												[
													-175.316,
													-138.407
												],
												[
													-176.889,
													-105.18
												],
												[
													-159.943,
													-98.378
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 37,
									s: [
										{
											i: [
												[
													-3.23,
													12.61
												],
												[
													-4.637,
													-20.922
												],
												[
													6.881,
													16.693
												]
											],
											o: [
												[
													-5.961,
													-1.297
												],
												[
													3.681,
													16.606
												],
												[
													-6.882,
													-16.694
												]
											],
											v: [
												[
													-162.789,
													-137.203
												],
												[
													-176.889,
													-105.18
												],
												[
													-159.943,
													-98.378
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 41,
									s: [
										{
											i: [
												[
													5.657,
													6.164
												],
												[
													1.061,
													-13.144
												],
												[
													2.437,
													17.89
												]
											],
											o: [
												[
													-1.142,
													7.793
												],
												[
													-1.369,
													16.954
												],
												[
													-2.82,
													-20.698
												]
											],
											v: [
												[
													-172.53,
													-136.849
												],
												[
													-176.889,
													-105.18
												],
												[
													-159.943,
													-98.378
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 46,
									s: [
										{
											i: [
												[
													6.963,
													6.965
												],
												[
													0.074,
													-14.175
												],
												[
													5.172,
													16.98
												]
											],
											o: [
												[
													-0.806,
													6.83
												],
												[
													1.264,
													16.689
												],
												[
													-0.286,
													-17.567
												]
											],
											v: [
												[
													-175.092,
													-135.839
												],
												[
													-176.889,
													-105.18
												],
												[
													-159.943,
													-98.378
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 52,
									s: [
										{
											i: [
												[
													-3.806,
													12.135
												],
												[
													-5.182,
													-17.921
												],
												[
													8.768,
													15.784
												]
											],
											o: [
												[
													-7.737,
													3.511
												],
												[
													4.725,
													16.34
												],
												[
													-8.822,
													-15.881
												]
											],
											v: [
												[
													-164,
													-136.338
												],
												[
													-176.889,
													-105.18
												],
												[
													-159.943,
													-98.378
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 59,
									s: [
										{
											i: [
												[
													5.657,
													6.164
												],
												[
													-0.52,
													-13.112
												],
												[
													2.437,
													17.89
												]
											],
											o: [
												[
													-1.142,
													7.793
												],
												[
													0.673,
													16.996
												],
												[
													-2.82,
													-20.698
												]
											],
											v: [
												[
													-175.53,
													-136.918
												],
												[
													-176.889,
													-105.18
												],
												[
													-159.943,
													-98.378
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 66,
									s: [
										{
											i: [
												[
													-0.269,
													12.521
												],
												[
													-4.29,
													-15.167
												],
												[
													6.553,
													16.824
												]
											],
											o: [
												[
													-6.736,
													2.982
												],
												[
													4.629,
													16.367
												],
												[
													-6.078,
													-15.603
												]
											],
											v: [
												[
													-168.784,
													-135.519
												],
												[
													-176.889,
													-105.18
												],
												[
													-159.943,
													-98.378
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 71,
									s: [
										{
											i: [
												[
													6.973,
													8.774
												],
												[
													0.048,
													-13.2
												],
												[
													1.493,
													13.777
												]
											],
											o: [
												[
													-1.374,
													9.325
												],
												[
													-0.062,
													17.009
												],
												[
													-1.666,
													-15.367
												]
											],
											v: [
												[
													-175.065,
													-135.118
												],
												[
													-176.889,
													-105.18
												],
												[
													-160.983,
													-97.436
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 74,
									s: [
										{
											i: [
												[
													11.209,
													2.563
												],
												[
													1.616,
													-11.653
												],
												[
													-1.928,
													17.952
												]
											],
											o: [
												[
													2.306,
													9.649
												],
												[
													-2.337,
													16.848
												],
												[
													2.002,
													-18.643
												]
											],
											v: [
												[
													-177.997,
													-133.163
												],
												[
													-176.889,
													-105.18
												],
												[
													-159.306,
													-95.998
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 85,
									s: [
										{
											i: [
												[
													-4.268,
													11.993
												],
												[
													-4.29,
													-15.167
												],
												[
													8.132,
													16.12
												]
											],
											o: [
												[
													-11.517,
													2.335
												],
												[
													4.629,
													16.367
												],
												[
													-6.526,
													-12.936
												]
											],
											v: [
												[
													-162.947,
													-136.578
												],
												[
													-176.889,
													-105.18
												],
												[
													-158.668,
													-98.336
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 98,
									s: [
										{
											i: [
												[
													-1.771,
													10.341
												],
												[
													-3.625,
													-17.165
												],
												[
													6.971,
													16.655
												]
											],
											o: [
												[
													-7.713,
													5.643
												],
												[
													3.515,
													16.642
												],
												[
													-7.856,
													-18.769
												]
											],
											v: [
												[
													-167.92,
													-138.123
												],
												[
													-176.889,
													-105.18
												],
												[
													-159.943,
													-98.378
												]
											],
											c: true
										}
									]
								},
								{
									t: 106,
									s: [
										{
											i: [
												[
													-1.771,
													10.341
												],
												[
													-2.278,
													-23.527
												],
												[
													4.997,
													17.35
												]
											],
											o: [
												[
													-5.961,
													-1.297
												],
												[
													1.639,
													16.93
												],
												[
													-5.619,
													-19.508
												]
											],
											v: [
												[
													-162.789,
													-137.203
												],
												[
													-176.889,
													-105.18
												],
												[
													-159.943,
													-98.378
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								0.807843197093,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 25,
		ty: 4,
		nm: "tail piece 3",
		parent: 26,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1.08
							]
						},
						o: {
							x: [
								0.31
							],
							y: [
								0.221
							]
						},
						t: 0,
						s: [
							15
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0.074
							]
						},
						t: 9,
						s: [
							7
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 14,
						s: [
							21
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 18,
						s: [
							1
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 22,
						s: [
							12
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 26,
						s: [
							-1
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 30,
						s: [
							14
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 34,
						s: [
							-2
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 38,
						s: [
							17
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 43,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 49,
						s: [
							19
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 57,
						s: [
							-1
						]
					},
					{
						i: {
							x: [
								0.777
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.488
							],
							y: [
								0
							]
						},
						t: 64,
						s: [
							12
						]
					},
					{
						i: {
							x: [
								0.658
							],
							y: [
								3.024
							]
						},
						o: {
							x: [
								0.4
							],
							y: [
								0
							]
						},
						t: 70,
						s: [
							-6
						]
					},
					{
						i: {
							x: [
								0.433
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.184
							],
							y: [
								0.21
							]
						},
						t: 73,
						s: [
							-8
						]
					},
					{
						i: {
							x: [
								0.706
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.354
							],
							y: [
								0
							]
						},
						t: 82,
						s: [
							23.026
						]
					},
					{
						i: {
							x: [
								0.788
							],
							y: [
								0.723
							]
						},
						o: {
							x: [
								0.484
							],
							y: [
								0
							]
						},
						t: 98,
						s: [
							17.026
						]
					},
					{
						t: 105,
						s: [
							15
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-169,
					-105,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-168.5,
					-72.5,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										5.879,
										6.707
									],
									[
										-15.684,
										-26.495
									],
									[
										-2.283,
										10.957
									]
								],
								o: [
									[
										-13.898,
										-15.856
									],
									[
										9.555,
										16.142
									],
									[
										2.283,
										-10.957
									]
								],
								v: [
									[
										-166.242,
										-102.273
									],
									[
										-179.802,
										-74.91
									],
									[
										-160.617,
										-65.212
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								0.807843197093,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 26,
		ty: 4,
		nm: "tail piece 2",
		parent: 27,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1.038
							]
						},
						o: {
							x: [
								0.31
							],
							y: [
								0.167
							]
						},
						t: 0,
						s: [
							4
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0.021
							]
						},
						t: 8,
						s: [
							-11
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 12,
						s: [
							6
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 16,
						s: [
							-13
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 20,
						s: [
							7
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 24,
						s: [
							-14
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 28,
						s: [
							17
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 32,
						s: [
							-15
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 36,
						s: [
							14
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 41,
						s: [
							-15
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 47,
						s: [
							15
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 55,
						s: [
							-3
						]
					},
					{
						i: {
							x: [
								0.777
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.488
							],
							y: [
								0
							]
						},
						t: 62,
						s: [
							7
						]
					},
					{
						i: {
							x: [
								0.3
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.266
							],
							y: [
								0
							]
						},
						t: 68,
						s: [
							-1
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.377
							],
							y: [
								0
							]
						},
						t: 79,
						s: [
							13.026
						]
					},
					{
						i: {
							x: [
								0.832
							],
							y: [
								0.706
							]
						},
						o: {
							x: [
								0.586
							],
							y: [
								0
							]
						},
						t: 96,
						s: [
							7.025
						]
					},
					{
						t: 105,
						s: [
							4
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-161.5,
					-112.5,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-165.5,
					-56.25,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										6.142,
										5.749
									],
									[
										-20.543,
										-37.96
									],
									[
										-0.133,
										17.185
									]
								],
								o: [
									[
										-21.861,
										-20.462
									],
									[
										16.767,
										30.982
									],
									[
										0.16,
										-20.694
									]
								],
								v: [
									[
										-165.832,
										-100.58
									],
									[
										-185.5,
										-62.5
									],
									[
										-154.166,
										-58.462
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								0.807843197093,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 27,
		ty: 4,
		nm: "tail piece 1",
		parent: 22,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1.036
							]
						},
						o: {
							x: [
								0.31
							],
							y: [
								0.442
							]
						},
						t: 0,
						s: [
							0
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0.05
							]
						},
						t: 6,
						s: [
							-12
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 10,
						s: [
							-5
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 14,
						s: [
							-14
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 18,
						s: [
							-3
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 22,
						s: [
							-16
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 26,
						s: [
							-1
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 30,
						s: [
							-17
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 34,
						s: [
							2
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 39,
						s: [
							-15
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 45,
						s: [
							4
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 53,
						s: [
							-10
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.488
							],
							y: [
								0
							]
						},
						t: 60,
						s: [
							-5
						]
					},
					{
						i: {
							x: [
								0.3
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: 66,
						s: [
							-10.307
						]
					},
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0
							]
						},
						t: 77,
						s: [
							8.026
						]
					},
					{
						i: {
							x: [
								0.81
							],
							y: [
								1.199
							]
						},
						o: {
							x: [
								0.714
							],
							y: [
								0
							]
						},
						t: 94,
						s: [
							5.026
						]
					},
					{
						t: 105,
						s: [
							0
						]
					}
				],
				ix: 10
			},
			p: {
				a: 1,
				k: [
					{
						i: {
							x: 0.667,
							y: 1
						},
						o: {
							x: 0.556,
							y: 0
						},
						t: 0,
						s: [
							73.343,
							25.556,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						i: {
							x: 0.53,
							y: 1
						},
						o: {
							x: 0.477,
							y: 0
						},
						t: 17,
						s: [
							64.593,
							46.806,
							0
						],
						to: [
							0,
							0,
							0
						],
						ti: [
							0,
							0,
							0
						]
					},
					{
						t: 40,
						s: [
							73.343,
							25.556,
							0
						]
					}
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					-162.25,
					-67.5,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										1.161,
										16.755
									],
									[
										4.031,
										2.242
									],
									[
										-22.658,
										-33.879
									]
								],
								o: [
									[
										-0.728,
										-10.507
									],
									[
										-25.425,
										-14.145
									],
									[
										34.275,
										51.249
									]
								],
								v: [
									[
										-144.813,
										-86.233
									],
									[
										-156.591,
										-105.124
									],
									[
										-185.5,
										-62.5
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								1,
								0.807843197093,
								0,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 28,
		ty: 4,
		nm: "front l leg",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					239.5,
					153.822,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					279.173,
					95.811,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.533,
								0.533,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.622,
								0.622,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 0,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.376,
								0.376,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 15,
						s: [
							93,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.559,
								0.528,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 34,
						s: [
							103,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 44,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.408,
								0.408,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 65,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 72,
						s: [
							103.5,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 80,
						s: [
							103.5,
							100,
							100
						]
					},
					{
						t: 95,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.692,
										y: 1
									},
									o: {
										x: 0.324,
										y: 0
									},
									t: 12,
									s: [
										{
											i: [
												[
													-14.44,
													-11.046
												],
												[
													0,
													0
												],
												[
													-11.032,
													-0.88
												],
												[
													3.557,
													-12.125
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													7.231,
													1.672
												],
												[
													0,
													0
												]
											],
											o: [
												[
													47.891,
													36.635
												],
												[
													0,
													0
												],
												[
													23.685,
													1.889
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-29.548,
													0.297
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-123.094,
													-33.787
												],
												[
													-42.541,
													16.14
												],
												[
													105.533,
													21.148
												],
												[
													129.115,
													47.639
												],
												[
													103.348,
													47.652
												],
												[
													80.602,
													47.664
												],
												[
													-29.1,
													47.719
												],
												[
													-75.904,
													42.737
												],
												[
													-148.547,
													12.344
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.833,
										y: 0.833
									},
									o: {
										x: 0.54,
										y: 0
									},
									t: 26,
									s: [
										{
											i: [
												[
													-11.658,
													-13.951
												],
												[
													0,
													0
												],
												[
													-72.788,
													-6.175
												],
												[
													3.557,
													-12.125
												],
												[
													6.493,
													0.178
												],
												[
													11.357,
													0.686
												],
												[
													0,
													0
												],
												[
													6.888,
													2.763
												],
												[
													0,
													0
												]
											],
											o: [
												[
													38.664,
													46.269
												],
												[
													0,
													0
												],
												[
													23.675,
													2.008
												],
												[
													0,
													0
												],
												[
													-6.493,
													-0.178
												],
												[
													-11.005,
													-0.665
												],
												[
													-29.243,
													-4.247
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-102.632,
													-63.941
												],
												[
													-33.829,
													-2.398
												],
												[
													105.533,
													21.148
												],
												[
													129.115,
													47.639
												],
												[
													104.633,
													47.652
												],
												[
													78.098,
													46.037
												],
												[
													-25.4,
													30.871
												],
												[
													-70.883,
													18.756
												],
												[
													-138.363,
													-15.535
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.561,
										y: 1
									},
									o: {
										x: 0.167,
										y: 0.167
									},
									t: 35,
									s: [
										{
											i: [
												[
													-15.451,
													-9.38
												],
												[
													0,
													0
												],
												[
													-34.372,
													-2.881
												],
												[
													3.557,
													-12.125
												],
												[
													2.454,
													0.067
												],
												[
													4.292,
													0.259
												],
												[
													0,
													0
												],
												[
													7.101,
													2.084
												],
												[
													0,
													0
												]
											],
											o: [
												[
													50.632,
													30.738
												],
												[
													0,
													0
												],
												[
													23.681,
													1.934
												],
												[
													0,
													0
												],
												[
													-2.454,
													-0.067
												],
												[
													-4.159,
													-0.251
												],
												[
													-29.433,
													-1.42
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-121.123,
													-38.765
												],
												[
													-32.635,
													10.545
												],
												[
													105.592,
													21.327
												],
												[
													129.174,
													47.818
												],
												[
													103.893,
													47.831
												],
												[
													79.715,
													47.228
												],
												[
													-21.088,
													42.763
												],
												[
													-67.393,
													35.085
												],
												[
													-146.329,
													7.155
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 42,
									s: [
										{
											i: [
												[
													-14.44,
													-11.046
												],
												[
													0,
													0
												],
												[
													-11.032,
													-0.88
												],
												[
													3.557,
													-12.125
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													7.231,
													1.672
												],
												[
													0,
													0
												]
											],
											o: [
												[
													47.891,
													36.635
												],
												[
													0,
													0
												],
												[
													23.685,
													1.889
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-29.548,
													0.297
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-123.094,
													-33.787
												],
												[
													-42.541,
													16.14
												],
												[
													105.533,
													21.148
												],
												[
													129.115,
													47.639
												],
												[
													103.348,
													47.652
												],
												[
													80.602,
													47.664
												],
												[
													-29.1,
													47.719
												],
												[
													-75.904,
													42.737
												],
												[
													-148.547,
													12.344
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.408,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 65,
									s: [
										{
											i: [
												[
													-14.44,
													-11.046
												],
												[
													0,
													0
												],
												[
													-11.032,
													-0.88
												],
												[
													3.557,
													-12.125
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													7.231,
													1.672
												],
												[
													0,
													0
												]
											],
											o: [
												[
													47.891,
													36.635
												],
												[
													0,
													0
												],
												[
													23.685,
													1.889
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-29.548,
													0.297
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-123.094,
													-33.787
												],
												[
													-42.541,
													16.14
												],
												[
													105.533,
													21.148
												],
												[
													129.115,
													47.639
												],
												[
													109.708,
													47.649
												],
												[
													93.611,
													47.657
												],
												[
													-29.1,
													47.719
												],
												[
													-75.904,
													42.737
												],
												[
													-148.547,
													12.344
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 72,
									s: [
										{
											i: [
												[
													-15.065,
													-10.177
												],
												[
													0,
													0
												],
												[
													-11.032,
													-0.88
												],
												[
													3.557,
													-12.125
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													7.231,
													1.672
												],
												[
													0,
													0
												]
											],
											o: [
												[
													49.965,
													33.752
												],
												[
													0,
													0
												],
												[
													23.685,
													1.889
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-29.548,
													0.297
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-127.139,
													-29.048
												],
												[
													-42.541,
													16.14
												],
												[
													106.191,
													21.217
												],
												[
													129.773,
													47.708
												],
												[
													110.285,
													47.709
												],
												[
													94.121,
													47.71
												],
												[
													-29.1,
													47.719
												],
												[
													-75.904,
													42.737
												],
												[
													-149.832,
													18.501
												]
											],
											c: true
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 85,
									s: [
										{
											i: [
												[
													-15.065,
													-10.177
												],
												[
													0,
													0
												],
												[
													-11.032,
													-0.88
												],
												[
													3.557,
													-12.125
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													7.231,
													1.672
												],
												[
													0,
													0
												]
											],
											o: [
												[
													49.965,
													33.752
												],
												[
													0,
													0
												],
												[
													23.685,
													1.889
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-29.548,
													0.297
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-127.139,
													-29.048
												],
												[
													-42.541,
													16.14
												],
												[
													106.191,
													21.208
												],
												[
													129.773,
													47.699
												],
												[
													110.284,
													47.701
												],
												[
													94.121,
													47.703
												],
												[
													-29.1,
													47.719
												],
												[
													-75.904,
													42.737
												],
												[
													-149.832,
													18.501
												]
											],
											c: true
										}
									]
								},
								{
									t: 102,
									s: [
										{
											i: [
												[
													-14.44,
													-11.046
												],
												[
													0,
													0
												],
												[
													-11.032,
													-0.88
												],
												[
													3.557,
													-12.125
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													7.231,
													1.672
												],
												[
													0,
													0
												]
											],
											o: [
												[
													47.891,
													36.635
												],
												[
													0,
													0
												],
												[
													23.685,
													1.889
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-29.548,
													0.297
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											v: [
												[
													-123.094,
													-33.787
												],
												[
													-42.541,
													16.14
												],
												[
													105.408,
													21.208
												],
												[
													128.99,
													47.699
												],
												[
													109.598,
													47.701
												],
												[
													93.514,
													47.703
												],
												[
													-29.1,
													47.719
												],
												[
													-75.904,
													42.737
												],
												[
													-148.547,
													12.344
												]
											],
											c: true
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.580392156863,
								0.211764720842,
								0.556862745098,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								148.797,
								48.266
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 5",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 29,
		ty: 4,
		nm: "back l leg",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-178.254,
					146.177,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					32.235,
					139.897,
					0
				],
				ix: 1
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.379,
								0.379,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.276,
								0.276,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 68,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.695,
								0.695,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 74,
						s: [
							100,
							102,
							100
						]
					},
					{
						t: 85,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 1,
							k: [
								{
									i: {
										x: 0.578,
										y: 1
									},
									o: {
										x: 0.667,
										y: 0
									},
									t: 0,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													7.2,
													-9.2
												],
												[
													15.323,
													-21.651
												],
												[
													0,
													0
												],
												[
													-3.022,
													6.998
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													25.18,
													-12.081
												],
												[
													0,
													0
												],
												[
													-11.969,
													0
												],
												[
													12.841,
													-29.737
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6.921,
													15.209
												],
												[
													-23.116,
													52.603
												],
												[
													3.012,
													69.647
												],
												[
													-39.75,
													69.647
												],
												[
													-48.431,
													55.275
												],
												[
													-24.885,
													1.603
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.667,
										y: 1
									},
									o: {
										x: 0.333,
										y: 0
									},
									t: 17,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													11.636,
													-10.662
												],
												[
													21.759,
													-21.824
												],
												[
													0,
													0
												],
												[
													-3.934,
													6.529
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													25.18,
													-12.081
												],
												[
													0,
													0
												],
												[
													-11.969,
													0
												],
												[
													16.951,
													-28.128
												],
												[
													0,
													0
												]
											],
											v: [
												[
													15.421,
													14.198
												],
												[
													-20.616,
													52.486
												],
												[
													3.012,
													69.647
												],
												[
													-36.5,
													69.574
												],
												[
													-45.181,
													55.202
												],
												[
													2.115,
													-21.014
												]
											],
											c: false
										}
									]
								},
								{
									i: {
										x: 0.587,
										y: 1
									},
									o: {
										x: 0.538,
										y: 0
									},
									t: 25,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													11.636,
													-10.662
												],
												[
													21.759,
													-21.824
												],
												[
													0,
													0
												],
												[
													-3.934,
													6.529
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													25.18,
													-12.081
												],
												[
													0,
													0
												],
												[
													-11.969,
													0
												],
												[
													16.951,
													-28.128
												],
												[
													0,
													0
												]
											],
											v: [
												[
													15.421,
													14.198
												],
												[
													-20.616,
													52.486
												],
												[
													3.012,
													69.647
												],
												[
													-36.5,
													69.574
												],
												[
													-45.181,
													55.202
												],
												[
													2.115,
													-21.014
												]
											],
											c: false
										}
									]
								},
								{
									t: 41,
									s: [
										{
											i: [
												[
													0,
													0
												],
												[
													7.2,
													-9.2
												],
												[
													15.323,
													-21.651
												],
												[
													0,
													0
												],
												[
													-3.022,
													6.998
												],
												[
													0,
													0
												]
											],
											o: [
												[
													0,
													0
												],
												[
													25.18,
													-12.081
												],
												[
													0,
													0
												],
												[
													-11.969,
													0
												],
												[
													12.841,
													-29.737
												],
												[
													0,
													0
												]
											],
											v: [
												[
													6.921,
													15.209
												],
												[
													-23.116,
													52.603
												],
												[
													3.012,
													69.647
												],
												[
													-39.75,
													69.647
												],
												[
													-48.431,
													55.275
												],
												[
													-24.885,
													1.603
												]
											],
											c: false
										}
									]
								}
							],
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.579999976065,
								0.211999990426,
								0.556999954523,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								51.969,
								69.897
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 1",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 105,
		st: 0,
		bm: 0
	}
];
const markers = [
	{
		tm: 0,
		cm: "start loop",
		dr: 0
	},
	{
		tm: 104,
		cm: "end loop\r\n",
		dr: 0
	}
];
const animationData = {
	v: v,
	fr: fr,
	ip: ip,
	op: op,
	w: w,
	h: h,
	nm: nm,
	ddd: ddd,
	assets: assets,
	layers: layers,
	markers: markers
};

const epiLargeLoaderCss = ".epi-large-loader{--animationBackgroundColor:var(--brandAccent_s25);pointer-events:none;position:fixed;top:0;bottom:0;left:0;right:0;display:grid;place-items:center;opacity:0;-webkit-transition:opacity 250ms ease-in-out;transition:opacity 250ms ease-in-out}.epi-large-loader.is--visible{pointer-events:all;opacity:1}.epi-large-loader.m--background-primary{--animationBackgroundColor:var(--brandPrimary_s25)}.epi-large-loader.m--background-secondary{--animationBackgroundColor:var(--brandSecondary_s25)}.epi-large-loader__inner{display:grid;grid-template:\"animation\" 1fr \"loadingText\" 30%/1fr;place-items:center;height:50vh;min-height:300px;width:50vh;min-width:350px;border-radius:20px;padding:30px;background:var(--animationBackgroundColor)}.epi-large-loader__animation{width:100%;grid-area:animation}.epi-large-loader__text{display:grid;place-items:center;grid-area:loadingText;font-size:clamp(1px, 3.2rem, 32px);text-align:center;font-weight:600;color:var(--richBlack)}";

const EpiLargeLoader = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.klassName = `epi-large-loader`;
    /** Whether or not the loader is visible */
    this.isVisible = false;
    /** The background color to be used for the animation */
    this.backgroundColor = `accent`;
    /** The text to be displayed below the animation */
    this.loadingText = `Fetching...`;
  }
  async handleVisibilityChange(visible) {
    var _a, _b;
    if (visible) {
      if (this.animationContainer) {
        (_a = this.animation) === null || _a === void 0 ? void 0 : _a.destroy();
        const loadAnimation = await import('./lottie-45f8e758.js').then(function (n) { return n.l; }).then(m => m.default.loadAnimation);
        this.animation = loadAnimation({
          container: this.animationContainer,
          loop: true,
          autoplay: true,
          animationData,
        });
      }
    }
    if (!visible) {
      (_b = this.animation) === null || _b === void 0 ? void 0 : _b.stop();
      setTimeout(() => {
        var _a;
        (_a = this.animation) === null || _a === void 0 ? void 0 : _a.destroy();
      });
    }
  }
  /** The method to show the loader */
  async show(loadingText) {
    if (loadingText)
      this.loadingText = loadingText;
    this.isVisible = true;
  }
  /** The method to hide the loader */
  async hide() {
    this.isVisible = false;
  }
  /**
   * Lifecycle hooks in the order that they are called. Uncomment to use
  */
  // componentWillLoad() { }
  // componentDidLoad() { }
  // componentWillRender () { }
  // componentDidRender () { }
  // componentWillUpdate() { }
  // componentDidUpdate() { }
  /**
   * The render() function should always be the last one in the class
  */
  render() {
    return (h$1(Host, { class: klassList(this.klassName, this.isVisible && `is--visible`, `m--background-${this.backgroundColor}`) }, h$1("section", { class: `${this.klassName}__inner` }, h$1("section", { ref: (el) => this.animationContainer = el, class: `${this.klassName}__animation` }), h$1("p", { class: `${this.klassName}__text` }, this.loadingText))));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "isVisible": ["handleVisibilityChange"]
  }; }
};
EpiLargeLoader.style = epiLargeLoaderCss;

export { EpiLargeLoader as epi_large_loader };
